/* SAGAPO Koci Gabinet — Shopify integration v1. Native Shopify authentication; test game points only. */
(() => {
  'use strict';
  function boot() {
    const root = document.getElementById('sagapo-gabinet');
    if (!root || root.dataset.kgBooted) return;
    root.dataset.kgBooted = 'true';
    const controller = new AbortController();
    const listen = (target, type, fn) => target.addEventListener(type, fn, { signal: controller.signal });
    const config = JSON.parse(root.querySelector('#kg-config').textContent);
    const modules = {};
modules['./avatars.js'] = (() => {
// Native vector game pieces remain crisp in both a small profile and a puzzle cell.
const CAT_AVATARS = [
  { id: 'ginger', name: 'Rudy pręgowany', fur: '#eca55f', stripe: '#b96a32', muzzle: '#fff0d6', eyes: '#78b85e', bg: '#fff0df', pattern: 'tabby' },
  { id: 'black', name: 'Czarny', fur: '#34343e', muzzle: '#52515b', eyes: '#eac36b', bg: '#eeedf3', dark: true },
  { id: 'snow', name: 'Biały', fur: '#fffdfa', muzzle: '#f5e7df', eyes: '#8bbde0', bg: '#edf5fb' },
  { id: 'blue', name: 'Szary okrąglaczek', fur: '#a1a9b8', muzzle: '#d9dce3', eyes: '#e5b75e', bg: '#eef0f5', shape: 'round' },
  { id: 'silver', name: 'Srebrny pręgowany', fur: '#d5d5d8', stripe: '#73747f', muzzle: '#f6f2ef', eyes: '#80b68a', bg: '#f0f1f3', pattern: 'tabby' },
  { id: 'tuxedo', name: 'W smokingu', fur: '#383942', muzzle: '#fffdfa', eyes: '#a8c979', bg: '#efeff4', pattern: 'tuxedo', dark: true },
  { id: 'calico', name: 'Trikolor', fur: '#fff9ed', muzzle: '#fff5e5', eyes: '#8eb680', bg: '#fff2e6', pattern: 'calico' },
  { id: 'tortie', name: 'Szylkret', fur: '#51403b', muzzle: '#d9a578', eyes: '#d4ba67', bg: '#f5ece6', pattern: 'tortie', dark: true },
  { id: 'siamese', name: 'Syjamski', fur: '#ecdbc1', muzzle: '#d6b9a0', eyes: '#7ab9e3', bg: '#f7f1e6', pattern: 'point' },
  { id: 'cream', name: 'Kremowy', fur: '#efcf99', muzzle: '#fff2db', eyes: '#a1bb81', bg: '#fff7e8', shape: 'round' },
  { id: 'fluffy', name: 'Puszysty leśny', fur: '#b79c80', stripe: '#795f4b', muzzle: '#f4ead9', eyes: '#91b77c', bg: '#f0ece5', pattern: 'tabby', shape: 'fluffy' },
  { id: 'fold', name: 'Klapouszek', fur: '#beb9b1', muzzle: '#e7e1d9', eyes: '#d6aa62', bg: '#f3eeeb', shape: 'fold' }
];
const BASIC_CAT_IDS = ['ginger', 'snow', 'blue', 'black'];
CAT_AVATARS.forEach(avatar => { avatar.cost = BASIC_CAT_IDS.includes(avatar.id) ? 0 : 50; });
const PREMIUM_AVATARS = [
  { id: 'lilac', name: 'Lawendowy', fur: '#d9b7ee', stripe: '#a57ac2', muzzle: '#f9edff', eyes: '#88bdae', bg: '#f4ebff', pattern: 'tabby', cost: 100, story: 'Odrobina lawendy i dużo kociego spokoju.' },
  { id: 'tea', name: 'Herbaciany', fur: '#adc88c', stripe: '#718f51', muzzle: '#edf3dc', eyes: '#d7ac59', bg: '#eff5e7', pattern: 'tea', cost: 100, story: 'Zielona herbata, świeżość i spokojne mruczenie.' },
  { id: 'peach', name: 'Brzoskwiniowy', fur: '#f5b59e', stripe: '#db8c77', muzzle: '#fff0df', eyes: '#a1b987', bg: '#fff0e7', pattern: 'tabby', gradient: ['#ffe0b9', '#f0a4a5'], cost: 100, story: 'Ciepły, słodki odcień inspirowany brzoskwinią.' },
  { id: 'candy', name: 'Cukierek', fur: '#f3b9d2', muzzle: '#fff3ea', eyes: '#9794c7', bg: '#fff0f7', gradient: ['#f7b4d2', '#ffe3ad', '#c4e7d5', '#cdb8ef'], cost: 100, story: 'Pastelowy kotek z różem, brzoskwinią, miętą i lawendą.' }
];
const ALL_AVATARS = [...CAT_AVATARS, ...PREMIUM_AVATARS];

function avatarRewardId(avatar) { return `${avatar.id}-avatar`; }

function rewardAvatar(rewardId) {
  return ALL_AVATARS.find(avatar => avatar.cost > 0 && avatarRewardId(avatar) === rewardId);
}

function avatarUnlocked(state, id) {
  const avatar = ALL_AVATARS.find(avatar => avatar.id === id);
  if (!avatar) return false;
  if (!avatar.cost) return true;
  const redemption = state.redemptions?.[avatarRewardId(avatar)];
  return redemption?.type === 'digital' && (redemption.cost === avatar.cost || (id === 'lilac' && redemption.cost === 50));
}

function avatarFor(id) {
  return ALL_AVATARS.find(avatar => avatar.id === id) || CAT_AVATARS[0];
}

function availableAvatars(state) {
  return ALL_AVATARS.filter(avatar => avatarUnlocked(state, avatar.id));
}

function activeCat(state) {
  return state.cats.find(cat => cat.id === state.activeCatId) || null;
}

function selectedAvatar(state) {
  const id = activeCat(state)?.avatar || 'ginger';
  return avatarUnlocked(state, id) ? id : 'ginger';
}

let artSequence = 0;
function catAvatarSvg(id = 'ginger') {
  const a = avatarFor(id), outline = '#322b2a';
  const gradientId = `cat-fur-${a.id}-${++artSequence}`;
  const gradient = a.gradient ? `<defs><linearGradient id="${gradientId}" x1="0%" y1="0%" x2="100%" y2="100%">${a.gradient.map((color, index) => `<stop offset="${index / (a.gradient.length - 1) * 100}%" stop-color="${color}"/>`).join('')}</linearGradient></defs>` : '';
  const fur = a.gradient ? `url(#${gradientId})` : a.fur;
  const heads = {
    classic: 'M24 34 29 17 42 30Q50 26 58 30L71 17 76 34Q85 43 82 58 79 78 50 81 21 78 18 58 15 43 24 34Z',
    round: 'M23 36 26 20 41 31Q50 28 59 31L74 20 77 36Q89 46 83 63 78 80 50 83 22 80 17 63 11 46 23 36Z',
    fluffy: 'M23 35 28 14 42 29Q50 26 58 29L72 14 77 35 83 39 80 44 88 51 82 54 86 63 77 65 76 73 66 73 61 81 50 78 39 81 34 73 24 73 23 65 14 63 18 54 12 51 20 44 17 39Z',
    fold: 'M20 37Q18 23 28 25L42 31Q50 28 58 31L72 25Q82 23 80 37 89 46 83 62 78 80 50 82 22 80 17 62 11 46 20 37Z'
  };
  const head = heads[a.shape] || heads.classic;
  let markings = '';
  if (a.pattern === 'tabby') markings = `<path d="m41 33 3 8m6-10v9m9-7-3 8M23 47l7 3m-9 6 8 1m48-10-7 3m9 6-8 1" stroke="${a.stripe}" stroke-width="4" stroke-linecap="round"/>`;
  if (a.pattern === 'tea') markings = '<path d="M43 40q-5-11 8-12 6 8-8 12Z" fill="#668a47"/><path d="m45 37 5-5" stroke="#dcebbd" stroke-width="1.4" stroke-linecap="round"/><path d="m23 49 7 2m47-2-7 2" stroke="#799959" stroke-width="3" stroke-linecap="round"/>';
  if (a.pattern === 'tuxedo') markings = '<path d="M50 34 39 55Q29 65 35 73 50 83 65 73 71 65 61 55Z" fill="#fffdfa"/>';
  if (a.pattern === 'calico') markings = '<path d="m29 24 12 11 2 16q-13 11-22 2l3-16Z" fill="#e4a063"/><path d="m70 24-12 11 1 18q13 6 19-2l-4-14Z" fill="#49434a"/>';
  if (a.pattern === 'tortie') markings = '<path d="m30 24 11 12-1 18-17 3q-4-13 3-22Z" fill="#d09157"/><path d="m56 33 9-3 8 6-5 9-13-1Z" fill="#b97742"/><path d="m69 57 11 3-4 11-10 2-5-9Z" fill="#d79962"/>';
  if (a.pattern === 'point') markings = '<path d="m29 23 12 11-15 3Zm42 0L59 34l15 3Z" fill="#6b5146"/><path d="M29 45Q33 36 45 42L50 46l5-4q12-6 16 3l-3 17q-18 17-36 0Z" fill="#806253"/>';
  const ears = a.shape === 'fold'
    ? '<path d="m23 31 12 7-10 5m52-12-12 7 10 5" fill="#d8b6ad" stroke="#77615b" stroke-width="2.3" stroke-linejoin="round"/>'
    : `<path d="m29 34 3-10 8 10m20 0 8-10 3 10" fill="${a.dark ? '#b58b85' : '#edb4a6'}"/>`;
  const eyeLine = a.pattern === 'point' || a.dark ? '#211e20' : outline;
  const whisker = a.dark ? '#f0ddd0' : outline;
  return `<svg xmlns="http://www.w3.org/2000/svg" class="cat-mark" data-avatar-art="${a.id}" viewBox="0 0 100 100" fill="none" aria-hidden="true">${gradient}<path d="${head}" fill="${fur}"/>${ears}${markings}<ellipse cx="50" cy="65" rx="17" ry="10" fill="${a.muzzle}"/><ellipse cx="38" cy="51" rx="6.2" ry="7.4" fill="${a.eyes}" stroke="${eyeLine}" stroke-width="2"/><ellipse cx="62" cy="51" rx="6.2" ry="7.4" fill="${a.eyes}" stroke="${eyeLine}" stroke-width="2"/><ellipse cx="39" cy="51" rx="2.4" ry="5.1" fill="#1b2119"/><ellipse cx="61" cy="51" rx="2.4" ry="5.1" fill="#1b2119"/><circle cx="36.5" cy="48" r="1.6" fill="#fff"/><circle cx="59.5" cy="48" r="1.6" fill="#fff"/><path d="m46 60 4 3 4-3" fill="#d98279"/><path d="M50 63v3m-5 0q5 5 10 0" stroke="${outline}" stroke-width="2.4" stroke-linecap="round"/><path d="M29 61H16m14 6-12 3m53-9h13m-14 6 12 3" stroke="${whisker}" stroke-width="2.3" stroke-linecap="round"/><path d="${head}" stroke="${outline}" stroke-width="4" stroke-linejoin="round"/></svg>`;
}

return {CAT_AVATARS,PREMIUM_AVATARS,ALL_AVATARS,BASIC_CAT_IDS,avatarRewardId,rewardAvatar,avatarUnlocked,avatarFor,availableAvatars,activeCat,selectedAvatar,catAvatarSvg};
})();
modules['./engine.js'] = (() => {
const { avatarFor, availableAvatars, activeCat, avatarUnlocked, rewardAvatar, BASIC_CAT_IDS } = modules['./avatars.js'];

const STORAGE_KEY = 'sagapo.gabinet.preview.v1';
const ZONE = 'Europe/Warsaw';
const DAILY_LIMIT = 20;

function dayKey(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
  const get = key => parts.find(x => x.type === key).value;
  return `${get('year')}-${get('month')}-${get('day')}`;
}

function selectPuzzles(bank, day) {
  const days = Math.floor(Date.parse(`${day}T12:00:00Z`) / 86400000);
  return [5, 6, 7].map((size, i) => {
    const group = bank.filter(p => p.size === size);
    const base = group[((days + i * 7) % group.length + group.length) % group.length];
    return { ...base, challengeId: `${day}:${base.id}` };
  });
}

function emptyState() {
  return { schema: 1, claims: {}, redemptions: {}, sessions: {}, cats: [], activeCatId: null, sound: true, avatar: 'ginger', celebrationIndex: -1 };
}

function normalizeState(raw) {
  if (!raw || raw.schema !== 1) return emptyState();
  const result = emptyState();
  if (raw.sessions && typeof raw.sessions === 'object' && !Array.isArray(raw.sessions)) result.sessions = raw.sessions;
  if (raw.claims && typeof raw.claims === 'object' && !Array.isArray(raw.claims)) {
    for (const [key, claim] of Object.entries(raw.claims)) {
      if (!claim || claim.game !== 'meowdoku' || ![5, 10].includes(claim.amount) || !/^\d{4}-\d{2}-\d{2}$/.test(claim.day) || !/^meow-[567]-\d{2}$/.test(claim.puzzleId) || key !== `${claim.day}:${claim.puzzleId}`) continue;
      result.claims[key] = { day: claim.day, game: 'meowdoku', amount: claim.amount, puzzleId: claim.puzzleId };
    }
  }
  if (raw.redemptions && typeof raw.redemptions === 'object' && !Array.isArray(raw.redemptions)) {
    for (const [key, redemption] of Object.entries(raw.redemptions)) {
      const avatar = rewardAvatar(key);
      // Keep earlier purchases when these three cats become free.
      const previousBasicReward = BASIC_CAT_IDS.some(id => id !== 'ginger' && key === `${id}-avatar`) && redemption?.cost === 50;
      if (!redemption || (!previousBasicReward && (!avatar || (redemption.cost !== avatar.cost && !(avatar.id === 'lilac' && redemption.cost === 50))))) continue;
      result.redemptions[key] = { cost: redemption.cost, type: 'digital' };
    }
  }
  const restoredAvatar = avatarFor(raw.avatar).id;
  result.avatar = avatarUnlocked(result, restoredAvatar) ? restoredAvatar : 'ginger';
  const ids = new Set();
  result.cats = Array.isArray(raw.cats) ? raw.cats.filter(c => typeof c?.name === 'string').slice(0, 8).map((c, i) => {
    let id = typeof c.id === 'string' && /^[a-zA-Z0-9_-]{1,80}$/.test(c.id) && !ids.has(c.id) ? c.id : `cat-${i + 1}`;
    while (ids.has(id)) id += '-copy';
    ids.add(id);
    const avatar = avatarFor(c.avatar || result.avatar).id;
    return { id, name: c.name.slice(0, 40), color: ['rose', 'sage', 'lilac'].includes(c.color) ? c.color : 'rose', avatar: avatarUnlocked(result, avatar) ? avatar : 'ginger', ...(typeof c.avatarImageId === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(c.avatarImageId) ? { avatarImageId: c.avatarImageId } : {}) };
  }) : [];
  result.activeCatId = result.cats.some(c => c.id === raw.activeCatId) ? raw.activeCatId : null;
  result.sound = typeof raw.sound === 'boolean' ? raw.sound : true;
  result.celebrationIndex = Number.isSafeInteger(raw.celebrationIndex) && raw.celebrationIndex >= 0 ? raw.celebrationIndex : -1;
  return result;
}

function balance(state) {
  const earned = Object.values(state.claims).reduce((n, c) => n + (Number.isFinite(c.amount) && c.amount > 0 ? c.amount : 0), 0);
  const spent = Object.values(state.redemptions).reduce((n, c) => n + (Number.isFinite(c.cost) && c.cost > 0 ? c.cost : 0), 0);
  return Math.max(0, earned - spent);
}

function dailyClaims(state, day) {
  return Object.values(state.claims).filter(c => c.day === day && c.game === 'meowdoku');
}

function awardCompletion(state, puzzle, placements, day) {
  if (!puzzle.challengeId.startsWith(`${day}:`) || analyze(puzzle, placements).status !== 'complete') return { state, amount: 0, reason: 'invalid' };
  if (state.claims[puzzle.challengeId]) return { state, amount: 0, reason: 'already-claimed' };
  const today = dailyClaims(state, day);
  const earned = today.reduce((n, c) => n + c.amount, 0);
  const amount = Math.min(today.length === 0 ? 10 : 5, Math.max(0, DAILY_LIMIT - earned));
  if (!amount) return { state, amount: 0, reason: 'daily-limit' };
  return {
    state: { ...state, claims: { ...state.claims, [puzzle.challengeId]: { day, game: 'meowdoku', amount, puzzleId: puzzle.id } } },
    amount, reason: 'awarded'
  };
}

function redeemDigital(state, rewardId) {
  const avatar = rewardAvatar(rewardId);
  if (!avatar) return { state, ok: false, reason: 'unavailable' };
  if (state.redemptions[rewardId]) return { state, ok: false, reason: 'already-owned' };
  if (balance(state) < avatar.cost) return { state, ok: false, reason: 'insufficient' };
  return { state: { ...state, redemptions: { ...state.redemptions, [rewardId]: { cost: avatar.cost, type: 'digital' } } }, ok: true };
}

function chooseAvatar(state, id) {
  if (!availableAvatars(state).some(avatar => avatar.id === id)) return state;
  const current = activeCat(state);
  return { ...state, avatar: id, cats: state.cats.map(cat => cat.id === current?.id ? { ...cat, avatar: id } : cat) };
}

function chooseCat(state, id) {
  if (id === null) return { ...state, activeCatId: null, avatar: 'ginger' };
  const cat = state.cats.find(cat => cat.id === id);
  return cat ? { ...state, activeCatId: id, avatar: cat.avatar } : state;
}

function saveCatProfile(state, profile) {
  if (typeof profile.id !== 'string' || !/^[a-zA-Z0-9_-]{1,80}$/.test(profile.id) || typeof profile.name !== 'string' || !profile.name.trim() || !availableAvatars(state).some(avatar => avatar.id === profile.avatar)) return state;
  const index = state.cats.findIndex(cat => cat.id === profile.id);
  if (index < 0 && state.cats.length >= 8) return state;
  const cat = { ...state.cats[index], id: profile.id, name: profile.name.trim().slice(0, 40), color: state.cats[index]?.color || 'rose', avatar: profile.avatar };
  const cats = index < 0 ? [...state.cats, cat] : state.cats.map((old, i) => i === index ? cat : old);
  return { ...state, cats, avatar: state.activeCatId === cat.id ? cat.avatar : state.avatar };
}

function blankMarks(puzzle) {
  const cells = Array(puzzle.size * puzzle.size).fill(0);
  cells[puzzle.given[0] * puzzle.size + puzzle.given[1]] = 2;
  return cells;
}

const solutionCache = new WeakMap();

function analyze(puzzle, marks) {
  const n = puzzle.size;
  if (!Array.isArray(marks) || marks.length !== n * n || marks.some(x => ![0, 1, 2].includes(x))) return { status: 'invalid', bad: [] };
  const givenIndex = puzzle.given[0] * n + puzzle.given[1];
  if (marks[givenIndex] !== 2) return { status: 'invalid', bad: [givenIndex] };
  const cats = marks.flatMap((m, i) => m === 2 ? [i] : []);
  const bad = new Set();
  const buckets = [new Map(), new Map(), new Map()];
  for (const i of cats) {
    const r = Math.floor(i / n), c = i % n;
    [r, c, puzzle.regions[r][c]].forEach((k, group) => {
      const old = buckets[group].get(k) || [];
      old.push(i); buckets[group].set(k, old);
    });
  }
  for (const group of buckets) for (const list of group.values()) if (list.length > 1) list.forEach(i => bad.add(i));
  for (let a = 0; a < cats.length; a++) for (let b = a + 1; b < cats.length; b++) {
    const x = cats[a], y = cats[b];
    if (Math.abs(Math.floor(x / n) - Math.floor(y / n)) <= 1 && Math.abs(x % n - y % n) <= 1) { bad.add(x); bad.add(y); }
  }
  // Only use solution hints when the puzzle has exactly one solution.
  if (!solutionCache.has(puzzle)) {
    const solutions = countSolutions(puzzle, 2, true);
    solutionCache.set(puzzle, solutions.length === 1 ? solutions[0] : null);
  }
  const solution = solutionCache.get(puzzle);
  const misplaced = solution ? cats.filter(i => solution[Math.floor(i / n)] !== i % n) : [];
  misplaced.forEach(i => bad.add(i));
  return { status: bad.size ? 'conflict' : cats.length === n ? 'complete' : 'incomplete', bad: [...bad], misplaced, count: cats.length };
}

function countSolutions(puzzle, limit = 2, useGiven = true) {
  const n = puzzle.size, solutions = [];
  function dfs(r, cols, regions, previous, path) {
    if (solutions.length >= limit) return;
    if (r === n) { solutions.push([...path]); return; }
    for (let c = 0; c < n; c++) {
      if (useGiven && r === puzzle.given[0] && c !== puzzle.given[1]) continue;
      const region = puzzle.regions[r][c];
      if ((cols & (1 << c)) || (regions & (1 << region)) || (r && Math.abs(c - previous) <= 1)) continue;
      path.push(c); dfs(r + 1, cols | (1 << c), regions | (1 << region), c, path); path.pop();
    }
  }
  dfs(0, 0, 0, -10, []);
  return solutions;
}

function allRegionsConnected(puzzle) {
  const n = puzzle.size;
  for (let region = 0; region < n; region++) {
    const cells = [];
    for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (puzzle.regions[r][c] === region) cells.push(r * n + c);
    if (!cells.length) return false;
    const seen = new Set([cells[0]]), queue = [cells[0]];
    while (queue.length) {
      const i = queue.pop(), r = Math.floor(i / n), c = i % n;
      for (const [dr, dc] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
        const nr = r + dr, nc = c + dc, key = nr * n + nc;
        if (nr < 0 || nc < 0 || nr >= n || nc >= n || puzzle.regions[nr][nc] !== region || seen.has(key)) continue;
        seen.add(key); queue.push(key);
      }
    }
    if (seen.size !== cells.length) return false;
  }
  return true;
}

return {STORAGE_KEY,ZONE,DAILY_LIMIT,dayKey,selectPuzzles,emptyState,normalizeState,balance,dailyClaims,awardCompletion,redeemDigital,chooseAvatar,chooseCat,saveCatProfile,blankMarks,analyze,countSolutions,allRegionsConnected};
})();
modules['./gameplay.js'] = (() => {
const { analyze, awardCompletion } = modules['./engine.js'];

const CELEBRATIONS = ['Doskonale!', 'Wspaniale!', 'Idealnie!', 'Znakomicie!', 'Brawo!', 'Fantastycznie!', 'Mistrzostwo!', 'Pięknie!'];

// One transition owns validation, completion and rewards for mouse, touch and keyboard.
function applyBoardMove(state, puzzle, day, move) {
  const session = state.sessions[puzzle.challengeId];
  if (!session || session.finished) return { changed: false, state };
  const marks = [...session.marks], given = puzzle.given[0] * puzzle.size + puzzle.given[1];
  for (const index of new Set(move.indices)) {
    if (!Number.isInteger(index) || index < 0 || index >= marks.length || index === given) continue;
    if (move.type === 'tap') marks[index] = (marks[index] + 1) % 3;
    else if (move.type === 'paint' && [0, 1].includes(move.value) && marks[index] !== 2) marks[index] = move.value;
  }
  if (marks.every((value, index) => value === session.marks[index])) return { changed: false, state };
  const analysis = analyze(puzzle, marks), completed = analysis.status === 'complete';
  let next = { ...state, sessions: { ...state.sessions, [puzzle.challengeId]: { ...session, marks, finished: completed } } };
  let amount = 0, headline = '';
  if (completed) {
    const award = awardCompletion(next, puzzle, marks, day);
    next = award.state; amount = award.amount;
    next.celebrationIndex = ((Number.isInteger(state.celebrationIndex) ? state.celebrationIndex : -1) + 1) % CELEBRATIONS.length;
    headline = CELEBRATIONS[next.celebrationIndex];
  }
  return { changed: true, state: next, analysis, completed, amount, headline };
}

// Sample the whole movement so a fast drag also paints cells between pointer events.
function strokeCells(from, to, layout) {
  const { left, top, width, height, paddingX, paddingY, gapX, gapY, size } = layout;
  const cellWidth = (width - paddingX * 2 - gapX * (size - 1)) / size;
  const cellHeight = (height - paddingY * 2 - gapY * (size - 1)) / size;
  const steps = Math.max(1, Math.ceil(Math.hypot(to.x - from.x, to.y - from.y) / Math.max(1, Math.min(cellWidth, cellHeight) / 3)));
  const cells = new Set();
  for (let step = 0; step <= steps; step++) {
    const x = from.x + (to.x - from.x) * step / steps - left - paddingX;
    const y = from.y + (to.y - from.y) * step / steps - top - paddingY;
    if (x < 0 || y < 0) continue;
    const col = Math.floor(x / (cellWidth + gapX)), row = Math.floor(y / (cellHeight + gapY));
    if (col >= size || row >= size || x - col * (cellWidth + gapX) > cellWidth || y - row * (cellHeight + gapY) > cellHeight) continue;
    cells.add(row * size + col);
  }
  return [...cells];
}

return {CELEBRATIONS,applyBoardMove,strokeCells};
})();
modules['./sounds.js'] = (() => {
let soundOn=true, audioCtx=null;
function setSound(enabled){soundOn=enabled;}
function tone(freq=440,dur=.08,type='sine',gain=.035){
  if(!soundOn) return;
  try{
    if(!audioCtx) audioCtx=new (window.AudioContext||window.webkitAudioContext)();
    const o=audioCtx.createOscillator(), g=audioCtx.createGain();
    o.type=type;o.frequency.value=freq;g.gain.value=gain;
    o.connect(g);g.connect(audioCtx.destination);
    const t=audioCtx.currentTime;
    g.gain.setValueAtTime(gain,t);
    g.gain.exponentialRampToValueAtTime(.0001,t+dur);
    o.start(t);o.stop(t+dur);
  }catch(e){}
}
const VOLUME_BOOST=2.5;
function blip(freq,dur=.06,type='sine',gain=.025,delay=0,endFreq=null){
  if(!soundOn) return;
  try{
    if(!audioCtx) audioCtx=new (window.AudioContext||window.webkitAudioContext)();
    const o=audioCtx.createOscillator(),g=audioCtx.createGain();
    const t=audioCtx.currentTime+delay;
    o.type=type;o.frequency.setValueAtTime(freq,t);
    if(endFreq) o.frequency.exponentialRampToValueAtTime(endFreq,t+dur);
    g.gain.setValueAtTime(.0001,t);
    g.gain.exponentialRampToValueAtTime(Math.min(gain*VOLUME_BOOST,.18),t+.008);
    g.gain.exponentialRampToValueAtTime(.0001,t+dur);
    o.connect(g);g.connect(audioCtx.destination);o.start(t);o.stop(t+dur+.01);
  }catch(e){}
}
function noise(dur=.035,gain=.012,delay=0){
  if(!soundOn) return;
  try{
    if(!audioCtx) audioCtx=new (window.AudioContext||window.webkitAudioContext)();
    const len=Math.max(1,Math.floor(audioCtx.sampleRate*dur));
    const buf=audioCtx.createBuffer(1,len,audioCtx.sampleRate);
    const d=buf.getChannelData(0);
    for(let i=0;i<len;i++) d[i]=(Math.random()*2-1)*(1-i/len);
    const src=audioCtx.createBufferSource(),g=audioCtx.createGain();
    const t=audioCtx.currentTime+delay;
    src.buffer=buf;g.gain.value=Math.min(gain*VOLUME_BOOST,.18);src.connect(g);g.connect(audioCtx.destination);
    src.start(t);
  }catch(e){}
}
// X: soft tactile click
function soundX(){noise(.025,.010);blip(260,.035,'sine',.018,0,180)}
// Cat: playful two-part "meow/pop" synthesized locally
function soundCat(){
  blip(620,.075,'triangle',.026,0,820);
  blip(760,.11,'sine',.021,.055,470);
}
// Removing a mark: light airy pop
function soundClear(){blip(390,.045,'sine',.016,0,300)}
// Error: low double boop
function soundError(){
  blip(185,.10,'triangle',.026,0,145);
  blip(155,.12,'triangle',.022,.11,120);
}
// Level complete: bright bell sequence
function soundSuccess(){
  blip(523.25,.18,'sine',.025,0);
  blip(659.25,.18,'sine',.025,.10);
  blip(783.99,.25,'sine',.030,.20);
  blip(1046.5,.30,'sine',.020,.30);
}
// Next level: short swoosh-like rising cue
function soundNext(){
  noise(.07,.006);
  blip(280,.12,'sine',.018,0,520);
}
// Final completion: little "meow" + celebratory chord
function soundFinal(){
  soundCat();
  blip(523.25,.35,'sine',.022,.18);
  blip(659.25,.35,'sine',.022,.18);
  blip(783.99,.40,'sine',.025,.18);
  blip(1046.5,.45,'sine',.018,.34);
}


{soundX,soundCat,soundClear,soundError,soundSuccess,soundNext,soundFinal};

return {
  setSound,
  soundX,
  soundCat,
  soundClear,
  soundError,
  soundSuccess,
  soundNext,
  soundFinal
};
})();
const { STORAGE_KEY, dayKey, selectPuzzles, emptyState, normalizeState, balance, dailyClaims, redeemDigital, blankMarks, analyze, chooseCat, saveCatProfile } = modules['./engine.js'];
const { applyBoardMove, strokeCells } = modules['./gameplay.js'];
const { CAT_AVATARS, PREMIUM_AVATARS, ALL_AVATARS, BASIC_CAT_IDS, avatarFor, availableAvatars, activeCat, selectedAvatar, catAvatarSvg, avatarRewardId, rewardAvatar, avatarUnlocked } = modules['./avatars.js'];
const { setSound, soundX, soundCat, soundClear, soundError, soundSuccess, soundNext, soundFinal } = modules['./sounds.js'];

const $ = selector => root.querySelector(selector);
const escape = value => String(value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const colors = ['#fdccd6', '#daffe1', '#c9e5f3', '#ffd9bd', '#e3d3f2', '#fff0bd', '#a8ddca'];
const colorNames = ['różowy', 'zielony', 'niebieski', 'pomarańczowy', 'fioletowy', 'żółty', 'miętowy'];
const iconPaths = {
  home: '<path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z"/>',
  game: '<rect x="3" y="3" width="7" height="7" rx="2"/><rect x="14" y="3" width="7" height="7" rx="2"/><rect x="3" y="14" width="7" height="7" rx="2"/><path d="M17.5 14v7M14 17.5h7"/>',
  gift: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/>',
  box: '<path d="m12 3 9 5v9l-9 5-9-5V8Zm0 10v9M3 8l9 5 9-5M7 5.8l9 5"/>',
  cat: '<path d="m4 9 1-6 6 5h2l6-5 1 6c4 9-1 13-8 13S0 18 4 9Z"/><path d="M8 14h.01M16 14h.01m-6 4 2 1 2-1M4 16H1m19 0h3"/>',
  paw: '<ellipse cx="7" cy="7" rx="2.1" ry="3" transform="rotate(-23 7 7)"/><ellipse cx="12" cy="5" rx="2.1" ry="3"/><ellipse cx="17" cy="7" rx="2.1" ry="3" transform="rotate(23 17 7)"/><path d="M5 18c0-2 2-3 3-5 2-3 6-3 8 0 1 2 3 3 3 5 0 4-4 2-7 2s-7 2-7-2Z"/>',
  arrow: '<path d="M4 12h16m-6-6 6 6-6 6"/>',
  back: '<path d="M20 12H4m6-6-6 6 6 6"/>',
  check: '<path d="m5 12 4 4L19 6"/>',
  calendar: '<rect x="3" y="5" width="18" height="16" rx="3"/><path d="M7 3v4m10-4v4M3 11h18M8 15h2m4 0h2M8 18h2"/>',
  sound: '<path d="m4 9 4 0 5-5v16l-5-5H4ZM17 8q5 4 0 8m3-11q7 7 0 14"/>',
  mute: '<path d="m4 9 4 0 5-5v16l-5-5H4Zm13 0 5 6m0-6-5 6"/>',
  reset: '<path d="M4 10a8 8 0 1 1 1 8M4 4v6h6"/>',
  lock: '<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 4v3"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 6v6l4 2"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10h.01"/>',
  plus: '<path d="M12 4v16M4 12h16"/>',
  heart: '<path d="M12 21S1 14 2 7C3 1 10 2 12 6c2-4 9-5 10 1 1 7-10 14-10 14Z"/>',
  device: '<path d="M4 20h16l1-10a9 9 0 0 0-18 0l1 10Z"/><circle cx="12" cy="11" r="5"/><path d="M8 20v2m8-2v2"/>',
  leaf: '<path d="M20 3C10 2 2 7 4 16c9 5 17-3 16-13ZM3 22 15 9"/>',
  trophy: '<path d="M7 3h10v5a5 5 0 0 1-10 0V3Zm0 2H3v3a4 4 0 0 0 5 4m9-7h4v3a4 4 0 0 1-5 4m-4 1v6m-5 2h10m-8-2h6"/>',
  edit: '<path d="m16 3 5 5-12 12-6 1 1-6Z"/><path d="m14 5 5 5"/>',
  trash: '<path d="M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7m4-7v7"/>',
  external: '<path d="M14 3h7v7m0-7-11 11M10 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5"/>'
};
const icon = name => `<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${iconPaths[name] || iconPaths.paw}</svg>`;

function kgValidImageId(value) {
  return typeof value === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(value);
}
function kgCatProfileMark(cat) {
  if (!cat || !kgValidImageId(cat.avatarImageId)) return catAvatarSvg(cat?.avatar || 'ginger');
  return `<img class="kg-generated-avatar" src="/apps/koci-gabinet/avatars/${cat.avatarImageId}/image" alt="" aria-hidden="true" draggable="false" data-fallback-avatar="${escape(cat.avatar || 'ginger')}" style="display:block;width:100%;height:100%;max-width:100%;max-height:100%;object-fit:contain;pointer-events:none;user-select:none">`;
}
function catMark(variant) {
  if (variant !== undefined) return catAvatarSvg(variant);
  const cat = activeCat(state);
  return cat ? kgCatProfileMark(cat) : catAvatarSvg(selectedAvatar(state));
}
root.addEventListener('error', event => {
  const image = event.target;
  if (image.matches?.('img.kg-generated-avatar')) image.outerHTML = catAvatarSvg(image.dataset.fallbackAvatar || 'ginger');
}, { capture: true, signal: controller.signal });

const navItems = [{ key: 'home', label: 'Dzisiaj', icon: 'home' }, { key: 'game', label: 'Meowdoku', icon: 'game' }, { key: 'rewards', label: 'Nagrody', icon: 'gift' }, { key: 'packages', label: 'Moje paczki', icon: 'box' }, { key: 'cats', label: 'Moje koty', icon: 'cat' }, { key: 'account', label: 'Konto', icon: 'heart' }];
const levels = ['Łatwa', 'Średnia', 'Trudna'];
const scopedStorageKey = `sagapo.gabinet.shopify.test.v1:${config.storagePartition}`;
let storageOK = true;
let state;
try { state = normalizeState(JSON.parse(localStorage.getItem(scopedStorageKey) || 'null')); } catch { state = emptyState(); }
let bank = [], today = dayKey(), puzzles = [], activeLevel = 0, showNumbers = false, currentRoute = 'home', toastTimeout;
let gameMessage = null, badCells = [], lastDayCheck = today, pointerStroke = null;
setSound(state.sound);

const kgCatsEndpoint="/apps/koci-gabinet/cats";let kgCatsMode="loading",kgCatsRevision=0,kgCatsToken="",kgCatsAcknowledged="",kgCatsTimer,kgCatsRequest=null;function kgCatsSnapshot(){return{cats:state.cats.map(cat=>({id:cat.id,name:cat.name,avatar:cat.avatar,color:cat.color||"rose",...(kgValidImageId(cat.avatarImageId)?{avatarImageId:cat.avatarImageId}:{})})),activeCatId:state.activeCatId||null}}function kgStoreLocal(){try{localStorage.setItem(scopedStorageKey,JSON.stringify(state)),storageOK=!0}catch{storageOK=!1}}function persist(){kgStoreLocal(),kgCatsMode==="ready"&&(clearTimeout(kgCatsTimer),kgCatsTimer=setTimeout(kgSaveCats,350))}async function kgCatsFetch(options={}){const response=await fetch(kgCatsEndpoint,{...options,credentials:"same-origin",cache:"no-store",signal:AbortSignal.timeout(15e3)}),data=await response.json();if(!response.ok){const error=new Error(data.error||"Nie uda\u0142o si\u0119 zapisa\u0107 kot\xF3w.");throw error.status=response.status,error}return data}function kgApplyCats(profile){if(!profile||!Array.isArray(profile.cats)||profile.cats.length>8)throw new Error("Niepoprawne dane kot\xF3w z serwera.");const ids=new Set,cats=profile.cats.map(cat=>{if(!cat||typeof cat.id!="string"||!/^[a-zA-Z0-9_-]{1,80}$/.test(cat.id)||ids.has(cat.id)||typeof cat.name!="string"||!cat.name.trim()||cat.name.length>40||!ALL_AVATARS.some(avatar=>avatar.id===cat.avatar))throw new Error("Niepoprawny profil kota na serwerze.");return ids.add(cat.id),{id:cat.id,name:cat.name,avatar:cat.avatar,color:["rose","sage","lilac"].includes(cat.color)?cat.color:"rose",...(kgValidImageId(cat.avatarImageId)?{avatarImageId:cat.avatarImageId}:{})}}),activeCatId=profile.activeCatId||null;if(activeCatId&&!ids.has(activeCatId))throw new Error("Niepoprawny wyb\xF3r kota na serwerze.");state={...state,cats,activeCatId,avatar:cats.find(cat=>cat.id===activeCatId)?.avatar||"ginger"}}async function kgLoadCats(){try{const data=await kgCatsFetch();if(!Number.isSafeInteger(data.revision)||typeof data.token!="string")throw new Error("Niepoprawna odpowied\u017A serwera.");if(kgCatsRevision=data.revision,kgCatsToken=data.token,data.profile!==null){try{const backupKey=`${scopedStorageKey}:cats-before-cloud`;localStorage.getItem(backupKey)||localStorage.setItem(backupKey,JSON.stringify(kgCatsSnapshot()))}catch{}kgApplyCats(data.profile),kgStoreLocal(),kgCatsAcknowledged=JSON.stringify(kgCatsSnapshot())}kgCatsMode="ready",data.profile===null&&await kgSaveCats(),puzzles.length&&render()}catch(error){if(error.status===401){kgCatsMode="guest";return}kgCatsMode="error",toast("Nie uda\u0142o si\u0119 po\u0142\u0105czy\u0107 z profilami kot\xF3w. Od\u015Bwie\u017C stron\u0119.")}}async function kgSaveCats(){if(kgCatsMode!=="ready")return;if(kgCatsRequest)return kgCatsRequest;const profile=kgCatsSnapshot(),snapshot=JSON.stringify(profile);if(snapshot!==kgCatsAcknowledged)return kgCatsRequest=(async()=>{try{const expires=Number(kgCatsToken.split(".")[0]);if(!expires||expires*1e3<Date.now()+6e4){const fresh=await kgCatsFetch();if(fresh.revision!==kgCatsRevision)throw new Error("Profile zmieniono na innym urz\u0105dzeniu. Od\u015Bwie\u017C stron\u0119.");kgCatsToken=fresh.token}const data=await kgCatsFetch({method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({revision:kgCatsRevision,token:kgCatsToken,profile})});kgCatsRevision=data.revision,kgCatsToken=data.token,kgCatsAcknowledged=snapshot}catch(error){kgCatsMode="error",toast(`Koty nie zosta\u0142y zapisane na koncie. ${error.message}`)}finally{kgCatsRequest=null,kgCatsMode==="ready"&&JSON.stringify(kgCatsSnapshot())!==kgCatsAcknowledged&&(clearTimeout(kgCatsTimer),kgCatsTimer=setTimeout(kgSaveCats,350))}})(),kgCatsRequest}function kgCatsGuard(event){const target=event.target,isCatForm=event.type==="submit"&&target.id==="kg-catForm",isCatChoice=event.type==="change"&&target.matches?.('[name="playingCat"]');!isCatForm&&!isCatChoice||kgCatsMode==="ready"||kgCatsMode==="guest"||(event.preventDefault(),event.stopImmediatePropagation(),isCatChoice&&(target.checked=target.dataset.catId===state.activeCatId),toast(kgCatsMode==="loading"?"Chwilka \u2014 wczytuj\u0119 koty z konta.":"Zapis kot\xF3w jest niedost\u0119pny. Od\u015Bwie\u017C stron\u0119."))}root.addEventListener("submit",kgCatsGuard,{capture:!0,signal:controller.signal}),root.addEventListener("change",kgCatsGuard,{capture:!0,signal:controller.signal}),setTimeout(kgLoadCats,0);

function sessionFor(puzzle) {
  let session = state.sessions[puzzle.challengeId];
  if (!session || analyze(puzzle, session.marks).status === 'invalid') {
    session = { marks: blankMarks(puzzle), seconds: 0, finished: false };
    state.sessions[puzzle.challengeId] = session;
  }
  if (!Number.isFinite(session.seconds) || session.seconds < 0) session.seconds = 0;
  return session;
}

function niceDate(day = today) { return new Intl.DateTimeFormat('pl-PL', { day: 'numeric', month: 'long' }).format(new Date(`${day}T12:00:00Z`)); }
function earnedToday() { return dailyClaims(state, today).reduce((sum, c) => sum + c.amount, 0); }
function completedToday() { return puzzles.filter(p => state.claims[p.challengeId]).length; }
function rewardProgress() { return Math.min(100, balance(state) / 300 * 100); }
function nextAmount() { return completedToday() ? Math.min(5, 20 - earnedToday()) : 10; }
function timeString(seconds) { return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`; }
function toast(message) {
  $('#kg-toast').textContent = message; $('#kg-toast').classList.add('visible');
  clearTimeout(toastTimeout); toastTimeout = setTimeout(() => $('#kg-toast').classList.remove('visible'), 3500);
}

function openModal(html, variant = '') {
  $('#kg-modal').className = variant;
  $('#kg-modal').setAttribute('aria-label', variant === 'celebration-modal' ? 'Brawo, plansza rozwiązana!' : 'Okno Kociego Gabinetu');
  $('#kg-modalContent').innerHTML = html;
  if (!$('#kg-modal').open) $('#kg-modal').showModal();
}
function closeModal() { $('#kg-modal').close(); }
function ruleItems() {
  return `<div class="rule-list"><div class="rule-item"><span class="rule-step">1</span><div><strong>Jeden kot na kolor</strong><p>W każdym kolorowym obszarze umieść jednego kota.</p></div></div><div class="rule-item"><span class="rule-step">2</span><div><strong>Jeden w wierszu i kolumnie</strong><p>Każdy wiersz i każda kolumna potrzebują swojego kota.</p></div></div><div class="rule-item"><span class="rule-step">3</span><div><strong>Każdy lubi swoją przestrzeń</strong><p>Koty nie mogą się dotykać, również po skosie.</p></div></div></div>`;
}
function showRules() {
  openModal(`<div class="modal-symbol">${icon('game')}</div><h2>Mała instrukcja.<br>Dużo zabawy.</h2>${ruleItems()}<p>Kliknij lub dotknij pola: <strong>× → kot → puste</strong>. Przytrzymaj mysz lub palec i przeciągnij, aby wykluczyć kilka pól naraz. Zacznij na krzyżyku, aby je wymazywać. Przeciąganie nie usuwa kotów.</p><p>Błędy pojawiają się na bieżąco, a poprawne rozwiązanie zalicza się automatycznie. Kot z kłódką to podpowiedź. Na klawiaturze używaj strzałek i spacji.</p><button class="btn btn-dark btn-full" data-action="close-modal">Wszystko jasne ${icon('check')}</button>`);
}
function showPreviewInfo() {
  openModal(`<div class="modal-symbol">${icon('info')}</div><h2>Łapki na dobry początek</h2><p>Grasz w Meowdoku i odblokowujesz wyglądy kotów za <strong>testowe Łapki</strong>. Pierwsza ukończona plansza dnia daje 10 Łapek, kolejne dwie po 5.</p><p>Postęp gry i odblokowane wyglądy zapisują się obecnie <strong>tylko na tym urządzeniu</strong>. Profile kotów i przypisane awatary ze zdjęć są synchronizowane po zalogowaniu. Po zalogowaniu korzystasz z osobnego lokalnego zapisu dla swojego konta. Wyniki gościa nie przechodzą automatycznie na konto.</p><p>Łapek testowych nie wymienisz na produkty. Realne nagrody i zapis między urządzeniami pojawią się po uruchomieniu programu.</p><button class="btn btn-dark btn-full" data-action="close-modal">Rozumiem ${icon('check')}</button>`);
}

function renderNavigation() {
  $('#kg-navigation').innerHTML = navItems.map(n => `<a href="#${n.key}" class="nav-link ${currentRoute === n.key ? 'active' : ''}" ${currentRoute === n.key ? 'aria-current="page"' : ''}>${icon(n.icon)}<span>${n.label}</span>${n.key === 'game' ? `<span class="nav-count">${completedToday()}/3</span>` : ''}</a>`).join('');
  $('#kg-mobileNavigation').innerHTML = navItems.map(n => `<a href="#${n.key}" class="mobile-link ${currentRoute === n.key ? 'active' : ''}" ${currentRoute === n.key ? 'aria-current="page"' : ''}>${icon(n.icon)}<span>${n.key === 'packages' ? 'Paczki' : n.key === 'cats' ? 'Koty' : n.key === 'game' ? 'Graj' : n.label}</span></a>`).join('');
  $('#kg-pageName').textContent = navItems.find(n => n.key === currentRoute)?.label || 'Dzisiaj';
  $('#kg-walletBalance').textContent = balance(state);
  $('#kg-walletIcon').innerHTML = icon('paw');
  $('#kg-profileIcon').innerHTML = catMark();
  $('#kg-profileButton').style.background = avatarFor(selectedAvatar(state)).bg;
  $('#kg-profileButton').setAttribute('aria-label', `Moje koty. Aktualnie grasz: ${activeCat(state)?.name || 'kot SAGAPO'}`);
  $('#kg-profileButton').title = `${activeCat(state)?.name || 'Kot SAGAPO'} — Moje koty`;
  $('#kg-walletButton').setAttribute('aria-label', `${balance(state)} testowych Łapek. Przejdź do nagród.`);
}

function heading(eyebrow, title, subtitle, action = '') {
  return `<div class="page-heading"><div><p class="eyebrow">${eyebrow}</p><h2>${title}</h2><p class="page-subtitle">${subtitle}</p></div>${action || `<span class="date-label">${icon('calendar')}${niceDate()}</span>`}</div>`;
}

function miniBoard(puzzle) {
  return `<div class="mini-board" style="grid-template-columns:repeat(${puzzle.size},1fr)" aria-hidden="true">${puzzle.regions.flat().map((reg, i) => `<span style="background:${colors[reg]}">${i === puzzle.given[0] * puzzle.size + puzzle.given[1] ? catMark() : [1, 7, 18].includes(i) ? '<b class="mini-cross">×</b>' : ''}</span>`).join('')}</div>`;
}

function homeView() {
  const done = completedToday(), left = Math.max(0, 300 - balance(state));
  return `
<section class="hero">
  <span class="date-label kg-hero-date">
    ${icon('calendar')}${niceDate()}
  </span>

  <div class="hero-content">
    <p class="eyebrow">DLA KOTÓW. I ICH LUDZI.</p>
    <h2>Chwila dla Ciebie.<br>Łapka po łapce.</h2>
    <p>Rozwiąż dzisiejsze Meowdoku, zbieraj Łapki i odkrywaj swój koci świat.</p>

    <div class="hero-actions">
      <a href="#game" class="btn btn-dark">
        ${done === 3 ? 'Zagraj jeszcze raz' : 'Zagraj w Meowdoku'}
        ${icon('arrow')}
      </a>
      <button class="btn btn-text" data-action="rules">Jak to działa?</button>
    </div>
  </div>

  <img
    class="hero-image"
    src="${config.assets.hero}"
    width="1024"
    height="1024"
    alt="Kot SAGAPO o dużych zielonych oczach"
    fetchpriority="high"
  >
</section>
    <div class="dashboard-grid"><section class="card daily-card"><div class="card-heading"><div><p class="card-label">TWOJE CODZIENNE WYZWANIE</p><h2 class="card-title">Meowdoku dnia</h2></div><span class="badge">${done === 3 ? icon('check') + 'Ukończone' : 'Nowy zestaw'}</span></div><div class="daily-content">${miniBoard(puzzles[0])}<div class="daily-copy"><h3>Znajdź miejsce<br>dla każdego kota.</h3><p>Trzy plansze. Trzy poziomy.<br>Kilka minut tylko dla Ciebie.</p><div class="levels-dots">${puzzles.map((p, i) => `<span class="level-dot ${state.claims[p.challengeId] ? 'done' : i === done ? 'active' : ''}">${state.claims[p.challengeId] ? icon('check') : i + 1}</span>`).join('')}<small>${done}/3 zaliczone</small></div></div></div><div class="daily-bottom"><p>${icon('paw')}${earnedToday()}/20 testowych Łapek dzisiaj</p><a href="#game" class="btn btn-dark">${done ? 'Wróć do gry' : 'Zaczynamy'} ${icon('arrow')}</a></div></section>
    <div class="dashboard-stack"><section class="card balance-card"><div class="balance-top"><div><p class="card-label">TWOJE ŁAPKI</p><p class="balance-number">${balance(state)}<span>małych sukcesów</span></p></div><span class="paw-medallion">${icon('paw')}</span></div><div class="progress-track" role="progressbar" aria-label="Postęp do przykładowego prezentu" aria-valuemin="0" aria-valuemax="300" aria-valuenow="${Math.min(300, balance(state))}"><div class="progress-bar" style="width:${rewardProgress()}%"></div></div><div class="progress-copy"><span>${left ? `Jeszcze ${left} do przykładowego prezentu` : 'Próg przykładowej nagrody osiągnięty!'}</span><strong>${Math.min(300, balance(state))}/300</strong></div><p class="preview-note">Łapki testowe · zapis na tym urządzeniu.</p></section><section class="card package-card"><span class="tile-icon">${icon('box')}</span><div><h3>Twoje paczki w jednym miejscu</h3><p>Sprawdź historię zamówień i przejdź do zarządzania subskrypcją.</p><a class="subtle-link" href="#packages">Zobacz moje paczki ${icon('arrow')}</a></div></section></div></div>`;
}

function gameView() {
  const p = puzzles[activeLevel], session = sessionFor(p), claimed = !!state.claims[p.challengeId];
  const initialMessage = session.finished ? 'Plansza rozwiązana. Wynik zapisany automatycznie.' : 'Klikaj: × → kot → puste. Przytrzymaj i przeciągnij, żeby zaznaczać pola.';
  return `${heading('MAŁA PRZERWA DLA KOCIARZY', 'Meowdoku dnia', '')}
    <div class="game-layout"><section class="card game-card"><div class="game-tabs" role="tablist" aria-label="Poziom Meowdoku">${puzzles.map((puzzle, i) => `<button role="tab" aria-selected="${i === activeLevel}" aria-controls="kg-puzzle-panel" class="game-tab ${i === activeLevel ? 'active' : ''}" data-action="level" data-level="${i}">${state.claims[puzzle.challengeId] ? icon('check') : ''}${levels[i]} <span class="muted">${puzzle.size}×${puzzle.size}</span></button>`).join('')}</div><div id="kg-puzzle-panel" role="tabpanel" aria-label="Plansza Meowdoku"><div class="game-meta"><div><h2>${levels[activeLevel]} plansza</h2><p>${claimed ? 'Trening · bez kolejnych Łapek' : `Za ukończenie: +${nextAmount()} testowych Łapek`}</p></div><div class="game-utilities"><button class="icon-button" data-action="sound" aria-label="${state.sound ? 'Wyłącz dźwięki' : 'Włącz dźwięki'}" aria-pressed="${state.sound}">${icon(state.sound ? 'sound' : 'mute')}</button><button class="icon-button" data-action="rules" aria-label="Jak grać?">${icon('info')}</button><span class="timer" id="kg-timer">${timeString(session.seconds)}</span></div></div><div id="kg-board" class="board" role="group" aria-label="Plansza ${p.size} na ${p.size}" style="grid-template-columns:repeat(${p.size},minmax(0,1fr))"></div></div><div class="game-controls"><span class="drag-hint">Przeciągnij myszą lub palcem,<br>aby zaznaczyć kilka pól.</span><button class="btn btn-soft" data-action="clear">${icon('reset')} Wyczyść</button></div><div class="game-status ${gameMessage?.type || (claimed ? 'success' : '')}" id="kg-gameStatus" role="status" aria-live="polite">${escape(gameMessage?.text || initialMessage)}</div>${session.finished ? `<button class="btn btn-pink btn-full" style="margin-top:12px" data-action="next">${completedToday() === 3 ? 'Wróć do Gabinetu' : 'Kolejna plansza'} ${icon('arrow')}</button>` : ''}<div class="game-options"><span>${completedToday()}/3 zaliczone dzisiaj</span></div></section><aside class="game-aside"><section class="card"><h2>Każdy kot ma<br>swoje miejsce.</h2>${ruleItems()}</section><section class="card tip-card"><span class="inline-icon small">${icon('paw')} DOBRZE WIEDZIEĆ</span><h2 style="margin-top:14px">Łapki za zabawę</h2><p>Pierwsza ukończona plansza daje <strong>10 Łapek</strong>, kolejne dwie po <strong>5</strong>. Możesz próbować tyle razy, ile chcesz.</p><p>Liczy się rozwiązanie, nie szybkość. Codzienny zestaw zmienia się o północy czasu polskiego.</p></section></aside></div><p class="test-callout">${icon('info')} W tej wersji zbierasz testowe Łapki. Zapisują się na tym urządzeniu i nie uprawniają do odbioru produktów.</p>`;
}

function renderBoard() {
  const puzzle = puzzles[activeLevel], session = sessionFor(puzzle), n = puzzle.size;
  const focused = document.activeElement?.dataset?.cell;
  $('#kg-board').innerHTML = puzzle.regions.flat().map((region, i) => {
    const r = Math.floor(i / n), c = i % n, given = r === puzzle.given[0] && c === puzzle.given[1], mark = session.marks[i];
    return `<button class="cell ${given ? 'given' : ''} ${badCells.includes(i) ? 'bad' : ''}" data-cell="${i}" style="background:${colors[region]}" ${given || session.finished ? 'disabled' : ''} aria-label="Wiersz ${r + 1}, kolumna ${c + 1}, obszar ${region + 1} ${colorNames[region]}, ${given ? 'kot podpowiedź' : mark === 2 ? 'kot' : mark === 1 ? 'wykluczone' : 'puste'}">${mark === 2 ? catMark() : mark === 1 ? '<span class="cross-mark" aria-hidden="true">×</span>' : ''}${showNumbers ? `<span class="region-number" aria-hidden="true">${region + 1}</span>` : ''}${given ? `<span class="given-lock">${icon('lock')}</span>` : ''}</button>`;
  }).join('');
  if (focused !== undefined) $(`#kg-board [data-cell="${focused}"]`)?.focus({ preventScroll: true });
}

function avatarRewardCard(avatar) {
  const owned = avatarUnlocked(state, avatar.id), enough = balance(state) >= avatar.cost;
  return `<article class="card avatar-reward-card"><div class="avatar-reward-art" style="background:${avatar.bg}">${catMark(avatar.id)}${owned ? `<span class="avatar-owned-mark" aria-label="Odblokowany">${icon('check')}</span>` : ''}</div><div class="avatar-reward-body"><h3>${avatar.name}</h3>${avatar.story ? `<p>${avatar.story}</p>` : ''}<span class="avatar-reward-price">${icon('paw')} ${avatar.cost} Łapek</span><button type="button" class="btn ${owned || !enough ? 'btn-soft' : 'btn-dark'} btn-full" data-action="reward" data-reward="${avatarRewardId(avatar)}">${owned ? 'Odblokowany ' + icon('check') : enough ? 'Odbierz kota' : `Jeszcze ${avatar.cost - balance(state)} Łapek`}</button></div></article>`;
}

function rewardsView() {
  return `${heading('MAŁE SUKCESY, KOCIE NAGRODY', 'Twoje Łapki. Twoja kolekcja.', 'Odblokuj wygląd kota i przypisz go do swojego profilu.')}
    <section class="reward-intro"><div><p class="card-label">TWÓJ TESTOWY PORTFEL</p><div class="balance-number">${balance(state)}<span>Łapek do wykorzystania</span></div><p>Za pierwszą planszę 10. Za kolejne po 5.</p></div><button class="btn btn-white" data-action="points-info">${icon('info')} Zasady</button></section>
    <div class="collection-note"><span class="collection-default">${catMark('ginger')} Cztery podstawowe koty są zawsze darmowe.</span><span>${availableAvatars(state).length}/${ALL_AVATARS.length} wyglądów w kolekcji</span></div>
    <section class="avatar-reward-section"><div class="avatar-section-heading"><div><p class="eyebrow">ZNAJDŹ SWOJEGO ULUBIEŃCA</p><h2>Osiem kocich charakterów</h2></div><span class="reward-tier-price">${icon('paw')} 50 Łapek za kota</span></div><div class="avatar-reward-grid">${CAT_AVATARS.filter(avatar => avatar.cost > 0).map(avatarRewardCard).join('')}</div></section>
    <section class="avatar-reward-section"><div class="avatar-section-heading"><div><p class="eyebrow">INSPIROWANE ZAPACHAMI SAGAPO</p><h2>Koty z odrobiną magii</h2></div><span class="reward-tier-price">${icon('paw')} 100 Łapek za kota</span></div><div class="avatar-reward-grid premium-rewards">${PREMIUM_AVATARS.map(avatarRewardCard).join('')}</div></section>
    <div class="reward-grid other-rewards-grid"><article class="card reward-card"><div class="reward-art sage"><span class="art-badge">Propozycja programu</span><div class="gift-illustration" aria-hidden="true"></div></div><div class="reward-content"><h2>Prezent do paczki</h2><p>Mała przyjemność przy kolejnym opłaconym zamówieniu. Rodzaj prezentu ustalimy przed startem.</p><span class="reward-price">${icon('paw')}Przykładowo 300 Łapek</span><button class="btn btn-soft" data-action="reward" data-reward="parcel-gift">Jak odbiorę prezent? ${icon('arrow')}</button></div></article><article class="card reward-card"><div class="reward-art"><span class="art-badge">W kolejnych etapach</span><span class="paw-medallion" style="width:90px;height:90px">${icon('trophy')}</span></div><div class="reward-content"><h2>Kolekcja kocich sukcesów</h2><p>Odznaki, sezonowe wyzwania i kolejne małe powody, żeby wracać do Gabinetu.</p><span class="reward-price muted">W przygotowaniu</span><button class="btn btn-soft" data-action="reward" data-reward="future">Poznaj pomysł ${icon('arrow')}</button></div></article></div><p class="reward-future">Wyglądy kotów odblokowujesz za testowe Łapki w tej wersji. Prezenty do paczek są propozycją i nie są jeszcze dostępne do odbioru.</p>`;
}

function packagesView() {
  return `${heading('TWOJE ZAMÓWIENIA, PO TWOJEMU', 'Moje paczki', 'Historia zakupów i dostęp do Twojej subskrypcji.')}<div class="kg-native-panel">${$('#kg-orders-template').innerHTML}</div>`;
}

function accountView() {
  return `${heading('DOBRZE BYĆ U SIEBIE', 'Moje konto', 'Twoje konto SAGAPO — także przy zakupach bez subskrypcji.')}<div class="kg-native-panel">${$('#kg-account-template').innerHTML}</div>`;
}

function avatarChoices(selected, basicOnly = false) {
  const names = { ginger: 'Zante', snow: 'Biały', blue: 'Szary', black: 'Czarny' };
  const avatars = BASIC_CAT_IDS.map(avatarFor);
  if (!basicOnly) avatars.push(...availableAvatars(state).filter(avatar => !BASIC_CAT_IDS.includes(avatar.id)));
  return avatars.map(avatar => `<label class="avatar-radio"><input type="radio" name="catAvatar" value="${avatar.id}" ${avatar.id === selected ? 'checked' : ''} required><span class="avatar-choice"><span class="avatar-drawing" style="background:${avatar.bg}">${catMark(avatar.id)}</span><span class="avatar-option-name">${names[avatar.id] || avatar.name}</span><span class="avatar-option-check" aria-hidden="true">${icon('check')}</span></span></label>`).join('');
}

let kgAvatarTestEnabled = false;
async function kgCheckAvatarAccess() {
  if (!config.authenticated) return;
  try {
    const response = await fetch('/apps/koci-gabinet/avatars', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
    if (!response.ok) return;
    const data = await response.json();
    kgAvatarTestEnabled = data.enabled === true;
    if (kgAvatarTestEnabled && currentRoute === 'cats' && puzzles.length) render();
  } catch {}
}
setTimeout(kgCheckAvatarAccess, 0);

const kgAvatarStyle = document.createElement('style');
kgAvatarStyle.textContent = `
/* Portrait gallery: reference layout for Moje koty. */
#sagapo-gabinet .kg-cat-collection{display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,220px));gap:28px 24px;align-items:start;margin:30px 0 24px}
#sagapo-gabinet .kg-cat-tile{position:relative;display:flex;flex-direction:column;align-items:center;min-width:0;padding:8px 12px 0;background:transparent;border:0;box-shadow:none}
#sagapo-gabinet .kg-cat-select{position:relative;display:block;width:168px;max-width:calc(100% - 16px);margin:0;cursor:pointer}
#sagapo-gabinet .kg-cat-select-input{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);clip-path:inset(50%);border:0;white-space:nowrap}
#sagapo-gabinet .kg-cat-art{display:flex;align-items:center;justify-content:center;width:100%;aspect-ratio:1;background:#fff0df;border-radius:36px;overflow:hidden;transition:background-color .18s,box-shadow .18s}
#sagapo-gabinet .kg-cat-art>svg{display:block;width:100%;height:100%;max-width:100%;max-height:100%}
#sagapo-gabinet .kg-cat-select:hover .kg-cat-art{background:#fce7df;box-shadow:0 4px 16px #c18a9b16}
#sagapo-gabinet .kg-cat-tile.is-playing .kg-cat-art,#sagapo-gabinet .kg-cat-select-input:focus-visible + .kg-cat-art{outline:2px solid #d6668a;outline-offset:4px}
#sagapo-gabinet .kg-cat-tile .kg-cat-name{align-self:stretch;min-width:0;margin:12px 0 0;padding:0 0 3px;border-bottom:1px solid #f2ecef;text-align:center;font-size:18px;font-weight:600;line-height:1.3;overflow-wrap:anywhere}
#sagapo-gabinet .kg-cat-badge-space{display:flex;align-items:center;justify-content:center;min-height:29px;width:100%;padding:4px 0}
#sagapo-gabinet .kg-cat-playing-badge{display:inline-flex;align-items:center;justify-content:center;gap:5px;padding:3px 9px;border-radius:20px;background:#ffe0e9;color:#a12f55;font-size:11px;font-weight:600;line-height:1.25}
#sagapo-gabinet .kg-cat-playing-badge .icon{width:13px;height:13px;flex:none}
#sagapo-gabinet button.kg-cat-edit{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:39px;margin-top:9px;padding:9px 14px;border:1px solid transparent;border-radius:14px;background:#fff0f4;color:#242126;font:inherit;font-size:13px;line-height:1.3;cursor:pointer;transform:none;transition:background-color .15s}
#sagapo-gabinet button.kg-cat-edit.is-playing{background:#e95b87;color:#fff}
#sagapo-gabinet button.kg-cat-edit:hover{background:#f9d6e1;transform:none}
#sagapo-gabinet button.kg-cat-edit.is-playing:hover{background:#d94a77}
#sagapo-gabinet .kg-cat-edit .icon{width:17px;height:17px;flex:none}
#sagapo-gabinet button.kg-cat-remove{position:absolute;z-index:1;top:0;right:-10px;display:flex;align-items:center;justify-content:center;width:32px;height:32px;padding:8px;border:0;border-radius:50%;background:#fff;color:#73727b;cursor:pointer;transform:none;transition:background-color .15s,color .15s}
#sagapo-gabinet button.kg-cat-remove:hover{background:#ffe5ed;color:#b52645;transform:none}
#sagapo-gabinet .kg-cat-remove .icon{width:16px;height:16px;flex:none}
#sagapo-gabinet .kg-cat-add-tile{display:flex;align-items:flex-start;justify-content:center;padding:30px 12px 0}
#sagapo-gabinet button.kg-cat-add{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;width:168px;max-width:100%;aspect-ratio:1;padding:18px;border:1px dashed #f0b1c4;border-radius:50%;background:#fff9fb;color:#5b4c52;font:inherit;font-size:13px;line-height:1.35;text-align:center;cursor:pointer;transform:none;transition:background-color .15s,border-color .15s}
#sagapo-gabinet button.kg-cat-add:hover{background:#ffeaf1;border-color:#df7d9e;transform:none}
#sagapo-gabinet .kg-cat-add>.icon{width:28px;height:28px;color:#d2517b;flex:none}
#sagapo-gabinet .kg-cat-edit:focus-visible,#sagapo-gabinet .kg-cat-remove:focus-visible,#sagapo-gabinet .kg-cat-add:focus-visible{outline:2px solid #d6668a;outline-offset:3px}
#sagapo-gabinet .kg-cat-gallery-link{margin:8px 0 18px}
@media(max-width:600px){
  #sagapo-gabinet .kg-cat-collection{grid-template-columns:repeat(2,minmax(0,1fr));gap:24px 12px;margin-top:24px}
  #sagapo-gabinet .kg-cat-tile{padding:8px 4px 0}
  #sagapo-gabinet .kg-cat-select{max-width:calc(100% - 20px)}
  #sagapo-gabinet .kg-cat-art{border-radius:28px}
  #sagapo-gabinet .kg-cat-tile .kg-cat-name{font-size:16px}
  #sagapo-gabinet button.kg-cat-edit{font-size:12px;padding:9px 8px;gap:6px}
  #sagapo-gabinet .kg-cat-add-tile{padding:24px 8px 0}
  #sagapo-gabinet button.kg-cat-add{gap:8px;font-size:12px}
}

#sagapo-gabinet .pet-details button.kg-delete-cat,#sagapo-gabinet button.kg-delete-cat{display:block;margin:10px auto 0;padding:5px 8px;background:transparent;border:0;color:#b52645;font:inherit;font-size:12px;cursor:pointer}
#sagapo-gabinet button.kg-delete-cat:hover{text-decoration:underline}
#sagapo-gabinet button.kg-delete-cat-editor{margin:16px auto 0;font-size:14px}

#sagapo-gabinet .kg-cat-editor-heading{display:flex;align-items:center;justify-content:space-between;gap:16px;margin:16px 0 24px}
#sagapo-gabinet .kg-cat-editor-heading h2{margin:0;min-width:0}
#sagapo-gabinet .kg-cat-editor-heading #kg-catFormPreview{display:flex;align-items:center;justify-content:center;flex:0 0 64px;width:64px;height:64px;border-radius:18px;overflow:hidden}
#sagapo-gabinet .kg-cat-editor-heading #kg-catFormAvatarName{display:none!important}
#sagapo-gabinet #kg-catForm [data-action="avatar-editor"][hidden]{display:none!important}
#sagapo-gabinet #kg-editorAvatarPanel>h3:first-of-type,#sagapo-gabinet #kg-avatarPanel>h3:first-of-type{margin:0 0 16px}
#sagapo-gabinet [data-avatar-generate],#sagapo-gabinet [data-avatar-generate]:disabled{color:#000!important;-webkit-text-fill-color:#000!important;opacity:1!important;margin-top:16px!important}
#sagapo-gabinet #kg-catForm [data-action="avatar-editor"]{color:#000!important;-webkit-text-fill-color:#000!important;opacity:1!important;margin:0 0 16px}
#sagapo-gabinet #kg-catForm .avatar-gallery-form{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px}
#sagapo-gabinet #kg-catForm .avatar-radio{display:block;position:relative;min-width:0;width:auto;margin:0}
#sagapo-gabinet #kg-catForm .avatar-radio>input{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip-path:inset(50%);border:0;white-space:nowrap}
#sagapo-gabinet #kg-catForm .avatar-choice{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;gap:0;box-sizing:border-box;width:100%;height:100%;padding:14px 6px 10px;border:1px solid #efcbd6;border-radius:14px;background:#fff}
#sagapo-gabinet #kg-catForm .avatar-radio>input:checked+.avatar-choice{border-width:1px;border-color:#e95b87;outline:1px solid #e95b87;outline-offset:0;background:#fff5f8}
#sagapo-gabinet #kg-catForm .avatar-radio>input:focus-visible+.avatar-choice{outline:2px solid #d6668a;outline-offset:3px}
#sagapo-gabinet #kg-catForm .avatar-drawing{display:flex;align-items:center;justify-content:center;flex:0 0 60px;width:60px;height:60px;max-width:100%;margin:0 auto 10px}
#sagapo-gabinet #kg-catForm .avatar-drawing>svg{display:block;width:100%;height:100%;margin:0}
#sagapo-gabinet #kg-catForm .avatar-option-name{display:block;min-height:15px;margin:0;text-align:center;font-size:11px;line-height:1.3;overflow-wrap:anywhere}
#sagapo-gabinet #kg-catForm .avatar-option-check{position:absolute;top:5px;right:5px;display:flex;align-items:center;justify-content:center;width:16px;height:16px;opacity:0;pointer-events:none}
#sagapo-gabinet #kg-catForm .avatar-radio>input:checked+.avatar-choice .avatar-option-check{opacity:1}
#sagapo-gabinet #kg-catForm .kg-cat-photo-alternative{margin:24px 0 16px;text-align:center;color:#292429;font-size:14px;line-height:1.5}
#sagapo-gabinet #kg-catForm #kg-editorAvatarPanel{margin-bottom:16px}
#sagapo-gabinet #kg-catForm [data-avatar-gallery-section]>h3:first-child{margin:0 0 16px}
#sagapo-gabinet #kg-catForm [data-avatar-gallery-section][hidden]{display:none!important}
@media(max-width:420px){#sagapo-gabinet #kg-catForm .avatar-gallery-form{grid-template-columns:repeat(2,minmax(0,1fr))}}

#sagapo-gabinet [data-avatar-message]:empty{display:none}
#sagapo-gabinet [data-avatar-preview][hidden]{display:none!important}
#sagapo-gabinet .kg-avatar-upload-row{display:flex;align-items:center;gap:12px;padding:3px;overflow:visible;background:transparent;border:0;box-shadow:none}
#sagapo-gabinet .kg-avatar-pick{appearance:none;flex:none;display:inline-block;border:1px solid #b9aeb2;border-radius:10px;padding:10px 14px;background:#fff;color:#292429;font:inherit;line-height:1.25;cursor:pointer;transition:background-color .15s,border-color .15s;transform:none;box-shadow:none}
#sagapo-gabinet .kg-avatar-pick:hover{background:#f8c8d6;border-color:#d99aae;color:#292429;transform:none}
#sagapo-gabinet .kg-avatar-pick:focus-visible{outline:2px solid #d97498;outline-offset:2px}
#sagapo-gabinet .kg-avatar-filename,#sagapo-gabinet .kg-avatar-filename:hover{min-width:0;overflow-wrap:anywhere;flex:1;background:transparent;color:#686168;text-decoration:none;box-shadow:none;cursor:default}
#sagapo-gabinet .kg-avatar-delete{display:block;margin:12px auto 0;padding:5px 8px;border:0;background:transparent;color:#9e3559;font:inherit;font-size:13px;cursor:pointer}
#sagapo-gabinet .kg-avatar-delete:hover{text-decoration:underline}
#sagapo-gabinet .kg-avatar-pick:disabled,#sagapo-gabinet .kg-avatar-delete:disabled{opacity:.5;cursor:default}
`;
root.append(kgAvatarStyle);

let kgAvatarPanelSerial = 0;
async function kgAvatarApi(path = '', options = {}) {
  const response = await fetch('/apps/koci-gabinet/avatars' + path, {
    credentials: 'same-origin', cache: 'no-store', ...options,
    signal: AbortSignal.any([controller.signal, AbortSignal.timeout(30000)])
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Nie udało się połączyć z galerią.');
  return data;
}
function kgSaveDraftCat(form) {
  const nameInput = form.querySelector('[name="catName"]');
  const name = nameInput.value.trim();
  if (!name) { nameInput.focus({ preventScroll: true }); throw new Error('Podaj imię kota.'); }
  const avatar = form.querySelector('[name="catAvatar"]:checked')?.value;
  if (!avatar) throw new Error('Wybierz wygląd kota.');
  const index = form.dataset.index === '' ? null : Number(form.dataset.index);
  const cat = index === null ? null : state.cats[index];
  if (index !== null && !cat) throw new Error('Nie znaleziono profilu kota. Otwórz go ponownie.');
  const id = cat?.id || crypto.randomUUID();
  const saved = saveCatProfile(state, { id, name, avatar });
  if (saved === state) throw new Error('Nie udało się zapisać profilu. Wybierz dostępny wygląd kota.');
  state = saved;
  form.dataset.index = String(state.cats.findIndex(cat => cat.id === id));
  kgStoreLocal();
  return id;
}

async function kgOpenAvatarGallery({ host = null, catId: requestedCatId = null, draftForm = null } = {}) {
  let editorCatId = requestedCatId;
  if (kgCatsMode !== 'ready') return toast('Najpierw wczytaj profile kotów. Odśwież stronę, jeśli problem się powtarza.');
  await kgSaveCats();
  if (kgCatsMode !== 'ready' || JSON.stringify(kgCatsSnapshot()) !== kgCatsAcknowledged) return toast('Poczekaj na zapis profili kotów i spróbuj ponownie.');
  const serial = ++kgAvatarPanelSerial;
  if (!host) openModal(`<h2>Awatary Twoich kotów</h2><div id="kg-avatarPanel"><p role="status">Wczytujemy Twoją galerię…</p></div>`, 'cat-editor-modal');
  const panel = host || $('#kg-avatarPanel');
  panel.hidden = false;
  panel.innerHTML = '<p role="status">Wczytujemy Twoją galerię…</p>';
  const alive = () => panel.isConnected && $('#kg-modal').open && serial === kgAvatarPanelSerial;
  let photo = null, photoSerial = 0, working = false, info, request = null;
  const message = (text, isError = false) => {
    if (!alive()) return;
    const output = panel.querySelector('[data-avatar-message]');
    output.textContent = text;
    output.style.setProperty('color', isError ? '#c62828' : 'inherit', 'important');
    panel.querySelector('[data-avatar-pick]').setAttribute('aria-invalid', String(isError));
  };
  function updateGallery() {
    if (!alive()) return;
    const jobs = (info.jobs || []).filter(job => kgValidImageId(job.id) && job.status !== 'deleted' && (!draftForm || editorCatId) && (!editorCatId || job.catId === editorCatId));
    panel.querySelector('[data-avatar-gallery]').innerHTML = jobs.length ? jobs.map(job => {
      const cat = state.cats.find(cat => cat.id === job.catId);
      const selected = cat?.avatarImageId === job.id;
      return `<article style="border:1px solid ${selected ? '#dc7e9c' : '#eadfe3'};border-radius:16px;padding:12px;min-width:0"><p style="margin:0 0 8px;font-weight:600">${escape(cat?.name || 'Usunięty profil kota')}</p>${job.status === 'ready' ? `<img src="/apps/koci-gabinet/avatars/${job.id}/image" alt="Awatar kota ${escape(cat?.name || '')}" loading="lazy" style="display:block;width:100%;aspect-ratio:1;object-fit:contain"><button type="button" class="btn btn-soft btn-full" data-avatar-use="${job.id}" ${!cat || selected || working ? 'disabled' : ''}>${selected ? 'Wybrany ✓' : 'Użyj tego awatara'}</button>` : `<p>${job.status === 'running' ? 'Tworzymy awatar…' : 'Nie udało się utworzyć awatara.'}</p>`}${job.status !== 'running' ? `<button type="button" class="kg-avatar-delete" data-avatar-delete="${job.id}" ${working ? 'disabled' : ''}>Usuń awatar</button>` : ''}</article>`;
    }).join('') : '<p>Nie masz jeszcze wygenerowanych awatarów.</p>';
    const gallerySection = panel.querySelector('[data-avatar-gallery-section]');
    if (gallerySection) gallerySection.hidden = Boolean(draftForm && !jobs.length);
    panel.querySelector('[data-avatar-generate]').disabled = working || info.busy || info.remaining < 1 || (!draftForm && !state.cats.length);
    panel.querySelector('[data-avatar-file]').disabled = working;
    panel.querySelector('[data-avatar-cat]').disabled = working;
    panel.querySelector('[data-avatar-pick]').disabled = working;
    const saveButton = draftForm?.querySelector('[type="submit"]');
    if (saveButton) saveButton.disabled = working;
  }
  async function refresh() {
    info = await kgAvatarApi();
    if (!info.enabled) throw new Error('Ta funkcja jest na razie dostępna tylko na koncie testowym.');
    if (!Array.isArray(info.jobs)) throw new Error('Najpierw zainstaluj aktualizację galerii na serwerze.');
    updateGallery();
  }
  try {
    info = await kgAvatarApi();
    if (!alive()) return;
    if (!info.enabled) throw new Error('Ta funkcja jest na razie dostępna tylko na koncie testowym.');
    if (!Array.isArray(info.jobs)) throw new Error('Najpierw zainstaluj aktualizację galerii na serwerze.');
    panel.innerHTML = `<div data-avatar-gallery-section ${draftForm ? 'hidden' : ''}><h3>Twoja galeria</h3><div data-avatar-gallery style="display:grid;grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:12px"></div><hr class="kg-avatar-divider" style="margin:24px 0;border:0;border-top:1px solid #9d9d9d"></div>${draftForm ? '' : '<h3>Utwórz nowy awatar</h3>'}<label class="field-label" for="kg-avatarCat" ${editorCatId || draftForm ? 'hidden' : ''}>Profil kota</label><select class="text-input" id="kg-avatarCat" data-avatar-cat ${editorCatId || draftForm ? 'hidden style="display:none"' : ''}>${draftForm ? '<option value="">Nowy profil kota</option>' : state.cats.map(cat => `<option value="${escape(cat.id)}" ${cat.id === (editorCatId || state.activeCatId) ? 'selected' : ''}>${escape(cat.name)}</option>`).join('')}</select><label class="field-label" for="kg-avatarPhoto" style="margin-top:${draftForm ? 0 : 16}px">Zdjęcia kotka</label><div class="kg-avatar-upload-row"><input id="kg-avatarPhoto" data-avatar-file type="file" accept="image/jpeg,image/png,image/webp" hidden style="display:none!important"><button type="button" class="kg-avatar-pick" data-avatar-pick>Wybierz plik</button><span data-avatar-filename class="kg-avatar-filename">Nie wybrano pliku</span></div><img data-avatar-preview alt="Podgląd zdjęcia" hidden style="display:block;width:100%;max-height:220px;object-fit:contain;margin:14px auto"><p data-avatar-message role="status" style="overflow-wrap:anywhere;margin:8px 0 0"></p><button type="button" class="btn btn-dark btn-full" data-avatar-generate disabled>${draftForm ? 'Awatar ze zdjęcia' : 'Generuj awatar'}</button>`;
    updateGallery();
    panel.querySelector('[data-avatar-pick]').addEventListener('click', () => panel.querySelector('[data-avatar-file]').click());
    panel.querySelector('[data-avatar-file]').addEventListener('change', async event => {
      const version = ++photoSerial;
      photo = null; request = null; message(''); updateGallery();
      const file = event.target.files[0];
      panel.querySelector('[data-avatar-filename]').textContent = file?.name || 'Nie wybrano pliku';
      const preview = panel.querySelector('[data-avatar-preview]');
      preview.hidden = true;
      if (!file) return;
      if (file.size > 15 * 1024 * 1024) return message('Wybierz zdjęcie mniejsze niż 15 MB.');
      let bitmap;
      try {
        bitmap = await createImageBitmap(file);
        if (!alive() || version !== photoSerial) return;
        const scale = Math.min(1, 1024 / Math.max(bitmap.width, bitmap.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(bitmap.width * scale));
        canvas.height = Math.max(1, Math.round(bitmap.height * scale));
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        const data = canvas.toDataURL('image/jpeg', .85);
        photo = data.split(',')[1]; preview.src = data; preview.hidden = false;
        message('Zdjęcie gotowe. Możesz rozpocząć generowanie.');
      } catch { message('Nie udało się odczytać zdjęcia. Wybierz JPG, PNG lub WebP.'); }
      finally { bitmap?.close(); if (alive()) updateGallery(); }
    });
    panel.querySelector('[data-avatar-generate]').addEventListener('click', async () => {
      if (working) return;
      if (!photo) {
        message('Dodaj zdjęcie kotka.', true);
        panel.querySelector('[data-avatar-pick]').focus({ preventScroll: true });
        return;
      }
      if (draftForm) {
        if (kgCatsMode !== 'ready') return message('Poczekaj na wczytanie profili kotów i spróbuj ponownie.', true);
        try { editorCatId = kgSaveDraftCat(draftForm); }
        catch (error) { message(error.message, true); return; }
      }
      working = true; updateGallery();
      message('Rozpoczynamy generowanie. Możesz zamknąć to okno — wynik znajdziesz później w galerii.');
      try {
        if (draftForm) {
          await kgSaveCats();
          if (!alive()) return;
          if (kgCatsMode !== 'ready' || JSON.stringify(kgCatsSnapshot()) !== kgCatsAcknowledged) throw new Error('Nie udało się zapisać profilu na koncie. Odśwież stronę przed generowaniem.');
          const cat = state.cats.find(cat => cat.id === editorCatId);
          panel.querySelector('[data-avatar-cat]').innerHTML = `<option value="${escape(cat.id)}" selected>${escape(cat.name)}</option>`;
        }
        const catId = editorCatId || panel.querySelector('[data-avatar-cat]').value;
        const fresh = await kgAvatarApi();
        if (!request || request.catId !== catId) request = { requestId: crypto.randomUUID(), catId, photo };
        const job = await kgAvatarApi('', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...request, token: fresh.token }) });
        request = null; photo = null;
        await refresh();
        message(job.status === 'ready' ? 'Awatar gotowy — wybierz go w galerii.' : 'Tworzymy awatar. Zwykle zajmuje to kilka minut.');
      } catch (error) { try { await refresh(); } catch {} message(error.message + ' Jeśli połączenie się przerwało, sprawdź galerię przed ponownym generowaniem.'); }
      finally { working = false; if (alive()) updateGallery(); }
    });
    panel.addEventListener('click', async event => {
      const deleteButton = event.target.closest('[data-avatar-delete]');
      const button = deleteButton || event.target.closest('[data-avatar-use]');
      if (!button || working) return;
      if (deleteButton && !window.confirm('Usunąć ten awatar? Jeśli jest wybrany, kot wróci do wyglądu z galerii.')) return;
      working = true; updateGallery();
      try {
        await kgSaveCats();
        if (kgCatsMode !== 'ready' || JSON.stringify(kgCatsSnapshot()) !== kgCatsAcknowledged) throw new Error('Najpierw zapisz profile kotów i odśwież stronę.');
        const fresh = await kgCatsFetch();
        if (fresh.revision !== kgCatsRevision) throw new Error('Profil zmienił się na innym urządzeniu. Odśwież stronę.');
        await kgAvatarApi('/' + (deleteButton ? button.dataset.avatarDelete + '/delete' : button.dataset.avatarUse + '/accept'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: fresh.token, revision: fresh.revision }) });
        await kgLoadCats();
        if (kgCatsMode !== 'ready') throw new Error('Awatar zapisano. Odśwież stronę, aby go wczytać.');
        if (host) {
          kgRefreshCatEditor(editorCatId);
          await refresh();
          message(deleteButton ? 'Awatar usunięty.' : 'Awatar przypisany. Możesz dalej edytować imię kota.');
        } else if (deleteButton) {
          await refresh(); message('Awatar usunięty.');
        } else {
          closeModal(); render(); toast('Awatar zapisany przy profilu kota.');
        }
      } catch (error) { message(error.message); }
      finally { working = false; if (alive()) updateGallery(); }
    });
    // Poll only while the modal is visible. Finished images stay in the server gallery.
    while (alive()) {
      await new Promise(resolve => setTimeout(resolve, 3000));
      if (!alive()) break;
      if (!working && (info.busy || info.jobs.some(job => job.status === 'running'))) {
        const wasBusy = info.busy;
        await refresh();
        if (wasBusy && !info.busy) message('Generowanie zakończone. Gotowy awatar możesz wybrać w galerii.');
      }
    }
  } catch (error) {
    if (alive()) panel.textContent = error.message;
  }
}
listen(root, 'click', event => {
  const editor = event.target.closest('[data-action="avatar-editor"]');
  if (editor) {
    event.preventDefault();
    const host = $('#kg-editorAvatarPanel');
    if (host && !host.hidden) return;
    void kgOpenAvatarGallery({ host, catId: editor.dataset.catId }).catch(error => toast(error.message));
    return;
  }
  if (!event.target.closest('[data-action="avatar-gallery"]')) return;
  event.preventDefault();
  void kgOpenAvatarGallery().catch(error => toast(error.message));
});

function catsView() {
  const cats = state.cats, current = activeCat(state);
  const list = `<div class="kg-cat-collection">${cats.map((cat, i) => {
    const selected = cat.id === current?.id;
    return `<article class="kg-cat-tile ${selected ? 'is-playing' : ''}" aria-label="Profil kota ${escape(cat.name)}">
      <button type="button" class="kg-cat-remove" data-action="delete-cat" data-cat-id="${escape(cat.id)}" aria-label="Usuń kota ${escape(cat.name)}" title="Usuń kota">${icon('trash')}</button>
      <label class="kg-cat-select" title="${selected ? 'Odznacz kota do gry' : 'Wybierz kota do gry'}">
        <input class="kg-cat-select-input" type="checkbox" name="playingCat" data-cat-id="${escape(cat.id)}" aria-label="Graj kotem ${escape(cat.name)}" ${selected ? 'checked' : ''}>
        <span class="kg-cat-art">${kgCatProfileMark(cat)}</span>
      </label>
      <h2 class="kg-cat-name">${escape(cat.name)}</h2>
      <button type="button" class="kg-cat-edit ${selected ? 'is-playing' : ''}" data-action="edit-cat" data-index="${i}">${icon('edit')}<span>Edytuj profil</span></button>
      <div class="kg-cat-badge-space">${selected ? `<span class="kg-cat-playing-badge">${icon('game')} Grasz tym kotem</span>` : ''}</div>
    </article>`;
  }).join('')}${cats.length < 8 ? `<div class="kg-cat-add-tile"><button type="button" class="kg-cat-add" data-action="add-cat">${icon('plus')}<span>Dodaj<br>kolejnego kota</span></button></div>` : ''}</div>`;
  return `${heading('BO KAŻDY KOT JEST WYJĄTKOWY', 'Poznajmy Twoją kocią ekipę.', 'Dodawaj i edytuj profile swoich kocich domowników.')}${list}${kgAvatarTestEnabled ? '<p class="kg-cat-gallery-link"><button type="button" class="btn btn-soft" data-action="avatar-gallery">Awatary ze zdjęć — galeria i generowanie</button></p>' : ''}<p class="cat-selection-hint">Kliknij podobiznę kota, którym chcesz grać. Kliknij ponownie, aby wrócić do standardowego kotka SAGAPO.</p>`;
}

function render() {
  renderNavigation();
  const views = { home: homeView, game: gameView, rewards: rewardsView, packages: packagesView, cats: catsView, account: accountView };
  $('#kg-view').innerHTML = `${storageOK ? '' : '<p class="no-storage" role="status">Przeglądarka nie pozwala zapisać postępów. Ta sesja działa, ale wynik może zniknąć po zamknięciu strony.</p>'}${views[currentRoute]()}`;
  // The public page title and canonical URL are supplied by the Shopify theme.
  if (currentRoute === 'game') renderBoard();
}

function route(focus = false) {
  cancelStroke();
  currentRoute = navItems.some(n => `#${n.key}` === location.hash) ? location.hash.slice(1) : 'home';
  gameMessage = null; badCells = [];
  render(); if (focus) root.scrollIntoView({ block: 'start', behavior: 'instant' });
  if (focus) $('#kg-main').focus({ preventScroll: true });
}

function navigate(view) { if (location.hash === `#${view}`) route(true); else location.hash = view; }
function chooseLevel(index) {
  if (!Number.isInteger(index) || index < 0 || index > 2) return;
  cancelStroke();
  activeLevel = index; gameMessage = null; badCells = []; soundNext();
  if (currentRoute !== 'game') navigate('game'); else render();
}

function toggleCell(index) {
  makeMove({ type: 'tap', indices: [index] });
}

function makeMove(move) {
  const puzzle = puzzles[activeLevel];
  if (!puzzle || currentRoute !== 'game') return;
  sessionFor(puzzle);
  const result = applyBoardMove(state, puzzle, today, move);
  if (!result.changed) return;
  state = result.state; badCells = result.analysis.bad;
  if (result.completed) {
    gameMessage = { type: 'success', text: result.amount ? `Wszystkie koty na swoim miejscu! +${result.amount} testowych Łapek zapisane.` : 'Plansza rozwiązana ponownie. Łapki za nią są już zapisane.' };
    cancelStroke(); persist(); render();
    completedToday() === 3 ? soundFinal() : soundSuccess();
    showCelebration(result.headline, result.amount);
  } else {
    const mark = state.sessions[puzzle.challengeId].marks[move.indices[0]];
    if (move.type === 'tap' && mark === 2 && result.analysis.bad.includes(move.indices[0])) soundError(); else if (move.type === 'tap' && mark === 2) soundCat(); else if (move.type === 'paint' ? move.value === 1 : mark === 1) soundX(); else soundClear();
    gameMessage = result.analysis.status === 'conflict'
      ? { type: 'error', text: result.analysis.misplaced?.length ? 'Ten kot nie pasuje do rozwiązania. Popraw pola zaznaczone na czerwono.' : 'Te koty są za blisko lub dzielą wiersz, kolumnę albo kolor. Popraw zaznaczone pola.' }
      : { type: '', text: `${result.analysis.count}/${puzzle.size} kotów na planszy. Rozwiązanie sprawdza się automatycznie.` };
    persist(); renderBoard();
    $('#kg-gameStatus').className = `game-status ${gameMessage.type}`;
    $('#kg-gameStatus').textContent = gameMessage.text;
  }
}

function showCelebration(headline, amount) {
  const last = completedToday() === 3;
  openModal(`<section class="celebration"><p class="eyebrow">KAŻDY KOT NA SWOIM MIEJSCU</p><h2>${escape(headline)}</h2><picture class="celebration-art"><source media="(prefers-reduced-motion: reduce)" srcset="${config.assets.celebrationStill}"><img src="${config.assets.celebration}${config.assets.celebration.includes('?') ? '&' : '?'}win=${state.celebrationIndex}-${Date.now()}" width="400" height="400" alt="Rudy kot SAGAPO radośnie mruga i kiwa głową wśród konfetti"></picture><div class="celebration-result">${amount ? `<span class="celebration-points">${icon('paw')} +${amount} Łapek</span><p>Testowe Łapki zostały zapisane w tej wersji.</p>` : '<span class="celebration-points">Piękne rozwiązanie!</span><p>To trening — Łapki za tę planszę masz już zapisane.</p>'}</div><button class="btn btn-dark btn-full" data-action="celebration-next">${last ? 'Wróć do Gabinetu' : 'Kolejna plansza'} ${icon('arrow')}</button><button class="btn btn-text" data-action="close-modal">Zobacz rozwiązanie</button></section>`, 'celebration-modal');
}

function cancelStroke() {
  const stroke = pointerStroke;
  pointerStroke = null;
  if (stroke?.board.hasPointerCapture(stroke.id)) stroke.board.releasePointerCapture(stroke.id);
  stroke?.board.classList.remove('is-painting');
}

function moveStroke(event) {
  const stroke = pointerStroke;
  if (!stroke || event.pointerId !== stroke.id) return;
  const point = { x: event.clientX, y: event.clientY };
  const cells = strokeCells(stroke.last, point, stroke.layout);
  if (!stroke.dragging && (cells.some(index => index !== stroke.startIndex) || Math.hypot(point.x - stroke.start.x, point.y - stroke.start.y) >= 8)) {
    stroke.dragging = true;
    stroke.board.classList.add('is-painting');
    cells.unshift(stroke.startIndex);
  }
  stroke.last = point;
  if (!stroke.dragging) return;
  const fresh = [...new Set(cells)].filter(index => !stroke.visited.has(index));
  fresh.forEach(index => stroke.visited.add(index));
  if (fresh.length) makeMove({ type: 'paint', indices: fresh, value: stroke.value });
}

function showReward(id) {
  const avatar = rewardAvatar(id);
  if (avatar) {
    const owned = avatarUnlocked(state, avatar.id), enough = balance(state) >= avatar.cost;
    openModal(`<div class="avatar-reward-preview" style="background:${avatar.bg}">${catMark(avatar.id)}</div><h2>${avatar.name}</h2><p>${avatar.story || 'Nowy koci charakter do Twojej kolekcji.'}</p><p>Po odblokowaniu wybierzesz ten wygląd przy dodawaniu lub edycji swojego kota. Odbierasz go raz i możesz używać w swoich profilach.</p><span class="avatar-modal-price">${icon('paw')} ${avatar.cost} testowych Łapek</span><p><strong>${owned ? 'Ten wygląd jest już w Twojej kolekcji.' : enough ? 'Masz wystarczająco Łapek, żeby go odebrać.' : `Brakuje Ci ${avatar.cost - balance(state)} Łapek.`}</strong></p>${owned ? `<button class="btn btn-dark btn-full" data-action="use-avatar" data-avatar-id="${avatar.id}">Użyj wyglądu w profilu ${icon('arrow')}</button>` : enough ? `<button class="btn btn-dark btn-full" data-action="redeem-digital" data-reward="${id}">Odbieram za ${avatar.cost} Łapek</button>` : '<button class="btn btn-dark btn-full" data-action="close-and-play">Zagraj po Łapki</button>'}`);
  } else if (id === 'parcel-gift') {
    openModal(`<div class="modal-symbol">${icon('gift')}</div><h2>Prezent razem<br>z kolejną paczką.</h2><p>Docelowo wybierzesz prezent za uzbierane Łapki, a my dołożymy go do kolejnego kwalifikującego się, opłaconego zamówienia — zwykłego albo z subskrypcji.</p><p>W tej wersji próg <strong>300 Łapek jest przykładowy</strong>. Realizacja prezentów będzie dostępna po uruchomieniu programu i połączeniu sklepu. Teraz nie rezerwujemy ani nie wysyłamy produktów.</p><button class="btn btn-dark btn-full" data-action="close-modal">Rozumiem ${icon('check')}</button>`);
  } else openModal(`<div class="modal-symbol">${icon('trophy')}</div><h2>Kolekcja małych sukcesów</h2><p>Odznaki za wyzwania, sezonowe plansze i nowe gry mogą później pojawić się obok Twoich Łapek. Wszystko w Twoim Gabinecie.</p><button class="btn btn-dark btn-full" data-action="close-modal">Brzmi dobrze ${icon('heart')}</button>`);
}

function kgRefreshCatEditor(catId) {
  const form = $('#kg-catForm'), cat = state.cats.find(cat => cat.id === catId);
  if (!form || !cat) return;
  const avatar = avatarFor(cat.avatar);
  $('#kg-catFormPreview').innerHTML = kgCatProfileMark(cat);
  $('#kg-catFormPreview').style.background = avatar.bg;
  $('#kg-catFormAvatarName').textContent = cat.avatarImageId ? 'Awatar ze zdjęcia' : avatar.name;
  form.querySelector('.avatar-fieldset').innerHTML = `<legend class="field-label">Wybierz jego wygląd</legend>${cat.avatarImageId ? `<input type="radio" name="catAvatar" value="${avatar.id}" checked hidden>` : `<div class="avatar-gallery avatar-gallery-form">${avatarChoices(avatar.id)}</div>`}`;
}

async function kgAutoOpenEditorGallery(cat) {
  const host = $('#kg-editorAvatarPanel'), form = $('#kg-catForm');
  if (!host || !form) return;
  try {
    let hasGenerated = kgValidImageId(cat.avatarImageId);
    if (!hasGenerated) {
      const info = await kgAvatarApi();
      hasGenerated = (info.jobs || []).some(job => job.catId === cat.id && job.status === 'ready');
    }
    if (!hasGenerated || !host.isConnected || $('#kg-catForm') !== form || !$('#kg-modal').open || !host.hidden) return;
    const button = form.querySelector('[data-action="avatar-editor"]');
    if (button) button.hidden = true;
    await kgOpenAvatarGallery({ host, catId: cat.id });
  } catch (error) {
    if (host.isConnected) toast(error.message);
  }
}

let kgDeletingCat = false;
async function kgDeleteCat(id, button) {
  if (kgDeletingCat) return;
  const cat = state.cats.find(cat => cat.id === id);
  if (!cat) return;
  if (!['ready', 'guest'].includes(kgCatsMode)) return toast('Poczekaj na wczytanie profili kotów.');
  if (!window.confirm(`Usunąć profil kota „${cat.name}”?`)) return;
  kgDeletingCat = true;
  button.disabled = true;
  try {
    if (kgCatsMode === 'guest') {
      state = { ...state, cats: state.cats.filter(cat => cat.id !== id), ...(state.activeCatId === id ? { activeCatId: null, avatar: 'ginger' } : {}) };
      kgStoreLocal();
    } else {
      await kgSaveCats();
      if (kgCatsMode !== 'ready' || JSON.stringify(kgCatsSnapshot()) !== kgCatsAcknowledged) throw new Error('Najpierw zapisz profile kotów i odśwież stronę.');
      const fresh = await kgCatsFetch();
      if (fresh.revision !== kgCatsRevision) throw new Error('Profile zmieniły się na innym urządzeniu. Odśwież stronę.');
      const profile = kgCatsSnapshot();
      profile.cats = profile.cats.filter(cat => cat.id !== id);
      if (profile.activeCatId === id) profile.activeCatId = null;
      const data = await kgCatsFetch({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ revision: fresh.revision, token: fresh.token, profile }) });
      kgApplyCats(data.profile);
      kgCatsRevision = data.revision;
      kgCatsToken = data.token;
      kgCatsAcknowledged = JSON.stringify(kgCatsSnapshot());
      kgStoreLocal();
    }
    ++kgAvatarPanelSerial;
    closeModal(); render(); toast('Profil kota został usunięty.');
  } finally {
    kgDeletingCat = false;
    if (button.isConnected) button.disabled = false;
  }
}

function catForm(index = null, initialAvatar = null) {
  if (index === null && state.cats.length >= 8) return toast('W podglądzie możesz dodać do 8 kotów.');
  if (index === null && kgAvatarTestEnabled && kgCatsMode !== 'ready') return toast('Poczekaj na wczytanie profili kotów i spróbuj ponownie.');
  const cat = index === null ? { name: '', avatar: 'ginger' } : state.cats[index];
  if (!cat) return;
  const avatar = avatarFor(initialAvatar && avatarUnlocked(state, initialAvatar) ? initialAvatar : cat.avatar);
  openModal(`
    <div class="kg-cat-editor-heading">
      <h2>${index === null ? 'Kto do nas dołącza?' : 'Twój koci domownik'}</h2>
      <span class="active-cat-preview" id="kg-catFormPreview" style="background:${avatar.bg}">${cat.avatarImageId ? kgCatProfileMark(cat) : catMark(avatar.id)}</span>
      <span id="kg-catFormAvatarName" hidden>${cat.avatarImageId ? 'Awatar ze zdjęcia' : avatar.name}</span>
    </div>
    <form id="kg-catForm" data-index="${index === null ? '' : index}">
      <label class="field-label" for="kg-catName">Imię kota</label>
      <input class="text-input" id="kg-catName" name="catName" placeholder="Na przykład: Mruczek" maxlength="40" value="${escape(cat.name)}" required autocomplete="off">
      <fieldset class="avatar-fieldset">
        <legend class="field-label">Wybierz jego wygląd</legend>
        ${cat.avatarImageId ? `<input type="radio" name="catAvatar" value="${avatar.id}" checked hidden>` : `<div class="avatar-gallery avatar-gallery-form">${avatarChoices(avatar.id, index === null && !initialAvatar)}</div>`}
      </fieldset>
      ${kgAvatarTestEnabled ? `
        <p class="kg-cat-photo-alternative">Albo zrób z własnego zdjęcia</p>
        <div id="kg-editorAvatarPanel"><p role="status">Wczytujemy wybór zdjęcia…</p></div>
      ` : ''}
      <p class="form-error" id="kg-catError" role="status"></p>
      <button class="btn btn-dark btn-full" type="submit">Zapisz profil ${icon('check')}</button>
      ${index !== null ? `<button type="button" class="kg-delete-cat kg-delete-cat-editor" data-action="delete-cat" data-cat-id="${escape(cat.id)}">Usuń kota</button>` : ''}
    </form>`, 'cat-editor-modal');
  setTimeout(() => $('#kg-catName')?.focus(), 0);
  if (kgAvatarTestEnabled) {
    void kgOpenAvatarGallery({ host: $('#kg-editorAvatarPanel'), catId: cat.id || null, draftForm: $('#kg-catForm') }).catch(error => toast(error.message));
  }
}

let boardPointerClickBlockedUntil = 0;

listen(root, 'keydown', event => {
  if ((event.key === 'Enter' || event.key === ' ') && event.target.closest('[data-cell]')) {
    boardPointerClickBlockedUntil = 0;
  }
});

listen(root, 'pointerdown', event => {
  const cell = event.target.closest('[data-cell]'), board = cell?.closest('#kg-board');
  if (!board || cell.disabled || pointerStroke || event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
  boardPointerClickBlockedUntil = performance.now() + 1000;
  event.preventDefault();
  cell.focus({ preventScroll: true });
  const rect = board.getBoundingClientRect(), css = getComputedStyle(board), index = Number(cell.dataset.cell);
  pointerStroke = {
    id: event.pointerId, board, startIndex: index, start: { x: event.clientX, y: event.clientY },
    last: { x: event.clientX, y: event.clientY }, dragging: false, visited: new Set(),
    value: sessionFor(puzzles[activeLevel]).marks[index] === 1 ? 0 : 1,
    layout: { left: rect.left + board.clientLeft, top: rect.top + board.clientTop, width: board.clientWidth, height: board.clientHeight, paddingX: parseFloat(css.paddingLeft), paddingY: parseFloat(css.paddingTop), gapX: parseFloat(css.columnGap) || 0, gapY: parseFloat(css.rowGap) || 0, size: puzzles[activeLevel].size }
  };
  board.setPointerCapture(event.pointerId);
});
listen(root, 'pointermove', moveStroke);
listen(root, 'pointerup', event => {
  if (!pointerStroke || pointerStroke.id !== event.pointerId) return;
  event.preventDefault();
  boardPointerClickBlockedUntil = performance.now() + 1000;
  moveStroke(event);
  const stroke = pointerStroke;
  cancelStroke();
  if (stroke && !stroke.dragging) toggleCell(stroke.startIndex);
});
listen(root, 'pointercancel', event => { if (pointerStroke?.id === event.pointerId) { boardPointerClickBlockedUntil = performance.now() + 1000; cancelStroke(); } });
listen(root, 'lostpointercapture', event => { if (pointerStroke?.id === event.pointerId) cancelStroke(); });
listen(window, 'blur', cancelStroke);

listen(root, 'click', event => {
  const cell = event.target.closest('[data-cell]');
  if (cell) {
    event.preventDefault();
    // Touch browsers may emit an extra click with detail 0 after pointerup.
    if (performance.now() < boardPointerClickBlockedUntil) return;
    if (!cell.disabled && event.detail === 0) toggleCell(Number(cell.dataset.cell));
    return;
  }
  const target = event.target.closest('[data-action]');
  if (!target) return;
  switch (target.dataset.action) {
    case 'rules': showRules(); break;
    case 'close-modal': closeModal(); break;
    case 'close-and-play': closeModal(); navigate('game'); break;
    case 'level': chooseLevel(Number(target.dataset.level)); break;
    case 'sound': state.sound = !state.sound; setSound(state.sound); persist(); render(); if (state.sound) soundCat(); break;
    case 'clear': { cancelStroke(); const p = puzzles[activeLevel]; state.sessions[p.challengeId] = { marks: blankMarks(p), seconds: 0, finished: false }; gameMessage = null; badCells = []; persist(); render(); soundClear(); break; }
    case 'celebration-next': closeModal();
    case 'next': { const next = puzzles.findIndex(p => !state.claims[p.challengeId]); if (next === -1) navigate('home'); else chooseLevel(next); break; }
    case 'points-info': showPreviewInfo(); break;
    case 'reward': showReward(target.dataset.reward); break;
    case 'redeem-digital': {
      const id = target.dataset.reward, redemption = redeemDigital(state, id);
      if (redemption.ok) { state = redemption.state; persist(); render(); soundSuccess(); showReward(id); toast(`Odblokowany kot: ${rewardAvatar(id).name}.`); }
      else { showReward(id); toast(redemption.reason === 'already-owned' ? 'Ten kot jest już odblokowany.' : 'Masz za mało Łapek.'); }
      break;
    }
    case 'use-avatar': {
      const index = state.cats.findIndex(cat => cat.id === state.activeCatId);
      closeModal(); navigate('cats'); catForm(index >= 0 ? index : state.cats.length ? 0 : null, target.dataset.avatarId); break;
    }
    case 'avatar-rewards': closeModal(); navigate('rewards'); break;
    case 'add-cat': catForm(); break;
    case 'edit-cat': catForm(Number(target.dataset.index)); break;
    case 'delete-cat': void kgDeleteCat(target.dataset.catId, target).catch(error => toast(error.message)); break;
  }
});

listen(root, 'submit', event => {
  if (event.target.id !== 'kg-catForm') return;
  event.preventDefault();
  const form = event.target, name = $('#kg-catName').value.trim(), avatar = form.querySelector('[name="catAvatar"]:checked')?.value;
  if (!name) { $('#kg-catError').textContent = 'Podaj imię kota.'; return; }
  if (!avatar) { $('#kg-catError').textContent = 'Wybierz wygląd kota.'; return; }
  const index = form.dataset.index === '' ? null : Number(form.dataset.index);
  if (index !== null && !state.cats[index]) return;
  const id = index === null ? crypto.randomUUID() : state.cats[index].id;
  const saved = saveCatProfile(state, { id, name, avatar });
  if (saved === state) { $('#kg-catError').textContent = 'Nie udało się zapisać profilu. Wybierz dostępny wygląd kota.'; return; }
  state = saved;
  persist(); closeModal(); render(); toast(`${name.slice(0, 40)} — profil zapisany.`);
});

listen(root, 'change', event => {
  if (event.target.name === 'playingCat') {
    const id = event.target.dataset.catId;
    state = chooseCat(state, event.target.checked ? id : null);
    persist(); render();
    $(`input[name="playingCat"][data-cat-id="${id}"]`)?.focus({ preventScroll: true });
    toast(activeCat(state) ? `Grasz kotem ${activeCat(state).name}.` : 'Grasz standardowym kotem SAGAPO.');
  }
  if (event.target.id === 'kg-regionNumbers') { showNumbers = event.target.checked; renderBoard(); }
  if (event.target.name === 'catAvatar') {
    const avatar = avatarFor(event.target.value);
    $('#kg-catFormPreview').innerHTML = catMark(avatar.id); $('#kg-catFormPreview').style.background = avatar.bg;
    $('#kg-catFormAvatarName').textContent = avatar.name;
  }
});
listen(root, 'keydown', event => {
  const cell = event.target.closest('[data-cell]');
  if (!cell || !['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
  event.preventDefault();
  const n = puzzles[activeLevel].size, start = Number(cell.dataset.cell), r = Math.floor(start / n), c = start % n;
  const direction = { ArrowUp: [-1, 0], ArrowDown: [1, 0], ArrowLeft: [0, -1], ArrowRight: [0, 1] }[event.key];
  let nr = r, nc = c;
  for (let tries = 0; tries < n; tries++) {
    nr = (nr + direction[0] + n) % n; nc = (nc + direction[1] + n) % n;
    const next = $(`[data-cell="${nr * n + nc}"]`);
    if (next && !next.disabled) { next.focus(); break; }
  }
});

$('#kg-modal .modal-close').addEventListener('click', closeModal);
$('#kg-modal').addEventListener('click', event => { if (event.target === $('#kg-modal')) { const box = $('#kg-modal').getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeModal(); } });
$('#kg-walletButton').addEventListener('click', () => navigate('rewards'));
$('#kg-profileButton').addEventListener('click', () => navigate('cats'));
$('#kg-previewInfo').addEventListener('click', showPreviewInfo);
listen(window, 'hashchange', () => { if (bank.length && (!location.hash || navItems.some(item => location.hash === `#${item.key}`))) route(true); });

function checkDay() {
  const now = dayKey();
  if (now !== lastDayCheck && bank.length) {
    cancelStroke(); closeModal();
    today = now; lastDayCheck = now; puzzles = selectPuzzles(bank, today); activeLevel = 0; gameMessage = null; badCells = []; render();
    toast('Nowy dzień, nowy koci zestaw. Miłej zabawy!');
  }
}
listen(window, 'focus', checkDay);
listen(document, 'visibilitychange', () => { if (document.hidden) persist(); else checkDay(); });
listen(window, 'pagehide', persist);
const ticker = setInterval(() => {
  if (document.hidden || $('#kg-modal').open) return;
  checkDay();
  if (currentRoute !== 'game' || !puzzles.length) return;
  const session = sessionFor(puzzles[activeLevel]);
  if (!session.finished) { session.seconds++; const timer = $('#kg-timer'); if (timer) timer.textContent = timeString(session.seconds); if (session.seconds % 5 === 0) persist(); }
}, 1000);

async function start() {
  try {
    const response = await fetch(config.assets.puzzles, { credentials: 'omit' });
    if (!response.ok) throw new Error('puzzle-bank-unavailable');
    bank = await response.json(); puzzles = selectPuzzles(bank, today);
    persist(); route();
  } catch {
    $('#kg-view').innerHTML = `<section class="card"><h1>Koty jeszcze się rozgaszczają.</h1><p class="page-subtitle">Nie udało się wczytać plansz. Odśwież stronę, aby spróbować ponownie.</p></section>`;
  }
}
listen(window, 'pageshow', event => { if (event.persisted) window.location.reload(); });
controller.signal.addEventListener('abort', () => { clearInterval(ticker); clearTimeout(toastTimeout); cancelStroke(); });
start();

    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { controller.abort(); delete root.dataset.kgBooted; }
    }, { signal: controller.signal });
  }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
